<template>
  <div class="info-container">
    <Header></Header>
    <div class="mainbox">
      <!-- 水印容器移到这里 -->
      <div class="watermark-container">
        <div class="watermark" v-if="userInfo">
          <div v-for="i in 100" :key="i" class="watermark-item">
            {{ userInfo.real_name }}({{ userInfo.uid }})
          </div>
        </div>
      </div>
      
      <!-- 顶部操作栏 -->
      <div class="page-header">
        <div class="left">
          <el-page-header @back="goBack" :content="caseInfo.title || '案件详情'">
          </el-page-header>
         
        </div>
        <div class="right">
          <el-tooltip 
            :content="caseInfo.can_edit ? '' : '无编辑权限'" 
            placement="top" 
            :disabled="Boolean(caseInfo.can_edit)">
            <div style="display: inline-block;">
              <el-button 
                type="primary" 
                icon="el-icon-edit" 
                @click="handleEdit"
                :disabled="!caseInfo.can_edit">
                编辑
              </el-button>
              <el-button 
                type="default" 
                icon="el-icon-date" 
                @click="setSchedule"
                :disabled="!caseInfo.can_edit">
                日程
              </el-button>
            </div>
          </el-tooltip>
          <el-dropdown trigger="click" @command="handleCommand">
            <el-button type="text">
              更多操作<i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <!-- <el-dropdown-item command="print">打印</el-dropdown-item>
              <el-dropdown-item command="export">导出</el-dropdown-item>
              <el-dropdown-item command="share">分享</el-dropdown-item> -->
              <el-tooltip 
                :content="caseInfo.can_edit ? '' : '无权限设置'" 
                placement="left" 
                :disabled="caseInfo.can_edit === 1">
                <div style="width: 100%" v-if="caseInfo.status != 5">
                  <el-dropdown-item 
                    command="complete" 
                    divided
                    :disabled="caseInfo.can_edit !== 1">
                    结案
                  </el-dropdown-item>
                </div>
              </el-tooltip>
              <el-tooltip 
                :content="caseInfo.can_edit ? '' : '无权限设置'" 
                placement="left" 
                :disabled="caseInfo.can_edit === 1">
                <div style="width: 100%" v-if="caseInfo.status == 5">
                  <el-dropdown-item 
                    command="cancelcomplete" 
                    divided
                    :disabled="caseInfo.can_edit !== 1">
                    取消结案
                  </el-dropdown-item>
                </div>
              </el-tooltip>
              <el-tooltip 
                :content="caseInfo.can_edit ? '' : '无权限设置'" 
                placement="left" 
                :disabled="caseInfo.can_edit === 1">
                <div style="width: 100%">
                  <el-dropdown-item 
                    command="cancel" 
                 
                    :disabled="caseInfo.can_edit !== 1">
                    取消
                  </el-dropdown-item>
                </div>
              </el-tooltip>
              <el-tooltip 
                :content="caseInfo.isadmin ? '' : '仅管理员可删除'" 
                placement="left" 
                :disabled="Boolean(caseInfo.isadmin)">
                <div style="width: 100%">
                  <el-dropdown-item 
                    command="delete"
                 
                    :disabled="caseInfo.isadmin !== 1"
                    class="danger-item">
                    删除
                  </el-dropdown-item>
                </div>
              </el-tooltip>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>

      
      <!-- 案件基本信息 -->
      <div class="info-section">
        <div class="section-header">
          <h3>基本信息(ID:{{ caseInfo.id }})</h3>
          <div class="status-tags">
            <el-tag :type="getStatusType">{{ getStatusText }}</el-tag>
            <span class="proxy-type" :class="getProxyTypeClass(caseInfo.proxyType)" style="height: 30px;line-height: 30px;">
              {{ getProxyTypeText(caseInfo.proxyType) }}
            </span>
          </div>
        </div>
        <el-descriptions :column="3" border>
          <el-descriptions-item label="案件名称" :span="3">{{ caseInfo.title }}</el-descriptions-item>
          <el-descriptions-item label="案号">{{ caseInfo.caseNumber }}</el-descriptions-item>
          <el-descriptions-item label="案件类型">{{ caseInfo.typename }}</el-descriptions-item>
          <el-descriptions-item label="承办人">{{ caseInfo.handlername }}</el-descriptions-item>
          
          <!-- <el-descriptions-item label="当事人" :span="3" class="party-info">
            <div class="party-details">
              <div class="detail-item">
                <span class="label">姓名：</span>
                <span class="value">{{ caseInfo.client }}</span>
              </div>
              <div class="detail-item">
                <span class="label">电话：</span>
                <span class="value">{{ caseInfo.phone }}</span>
              </div>
              <div class="detail-item">
                <span class="label">身份证：</span>
                <span class="value">{{ caseInfo.idCard }}</span>
              </div>
              <div class="detail-item full-width">
                <span class="label">地址：</span>
                <span class="value">{{ caseInfo.address }}</span>
              </div>
            </div>
          </el-descriptions-item>
          
          <el-descriptions-item label="对方当事人" :span="3" class="party-info">
            <div class="party-details">
              <div class="detail-item">
                <span class="label">姓名：</span>
                <span class="value">{{ caseInfo.defendant }}</span>
              </div>
              <div class="detail-item">
                <span class="label">电话：</span>
                <span class="value">{{ caseInfo.defendantPhone }}</span>
              </div>
              <div class="detail-item">
                <span class="label">身份证：</span>
                <span class="value">{{ caseInfo.defendantIdCard }}</span>
              </div>
              <div class="detail-item full-width">
                <span class="label">地址：</span>
                <span class="value">{{ caseInfo.defendantAddress }}</span>
              </div>
            </div>
          </el-descriptions-item> -->
          
          <el-descriptions-item label="案件描述" :span="3">
            <div class="description-content">{{ caseInfo.description || '暂无描述' }}</div>
          </el-descriptions-item>
          <el-descriptions-item label="备注" :span="3">
            <div class="description-content">{{ caseInfo.remark || '暂无备注' }}</div>
          </el-descriptions-item>
        </el-descriptions>
      </div>


      <!-- 人员信息 -->
      <div class="info-section">
        <div class="section-header">
          <h3>人员信息</h3>
          <el-button 
            v-if="caseInfo.can_edit"
            type="text" 
            icon="el-icon-plus"
            @click="handleAddPerson">
            添加人员
          </el-button>
        </div>

        <!-- 当事人信息 -->
        <div class="person-group">
          <div class="group-title">当事人</div>
          <div class="person-list">
            <!-- 案件主当事人 -->
            <div class="person-item main-person" v-if="caseInfo.client">
              <div class="person-header">
                <div class="person-name">
                  <span class="name">{{ caseInfo.client }}</span>
                  <el-tag size="small" type="primary">当事人</el-tag>
                </div>
                <div class="person-actions">
                  <!-- <el-button type="text" icon="el-icon-view" @click="viewPerson(caseInfo)">查看</el-button> -->
                </div>
              </div>
              <div class="person-info">
                <div class="info-item">
                  <span class="label">电话：</span>
                  <span class="value">{{ caseInfo.phone }}</span>
                </div>
                <div class="info-item">
                  <span class="label">身份证：</span>
                  <span class="value">{{ caseInfo.idCard }}</span>
                </div>
                <div class="info-item full-width">
                  <span class="label">地址：</span>
                  <span class="value">{{ caseInfo.address }}</span>
                </div>
              </div>
              <div class="info-item-warning">
                <div class="value" v-for="(item, index) in caseInfo.othercase1" :key="item.id"   @click="viewConflictCase(item)">
                  <div class="warning-item">
                    <span style="font-size: 15px;color: #000;">
                      {{ index + 1 }}： {{ item.title }} ({{ item.id }})
                    </span>
                    <span style="margin-left: 20px;" >
                     ({{ item.client }},{{ item.phone }},{{ item.idCard }})
                    </span>
                    <span style="margin-left: 20px;" v-if="item.type == 1">
                      ({{ item.defendant }},{{ item.defendantPhone }},{{ item.defendantIdCard }})
                    </span>
                    <span>
                      <el-tag size="small" type="danger" v-if="item.ctlx == 1">当事人冲突</el-tag>
                      <el-tag size="small" type="warning" v-if="item.ctlx == 2">对方当事人冲突</el-tag>
                      <el-tag size="small" type="info" v-if="item.ctlx == 3">其他当事人冲突</el-tag>
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <!-- 其他当事人列表 -->
            <div v-for="person in getPersonsByType(1)" 
                 :key="person.id"
                 class="person-item">
              <div class="person-header">
                <div class="person-name">
                  <span class="name">{{ person.name }}</span>
                  <el-tag size="small" type="info">{{ person.caselink }}</el-tag>
                  <span class="remark" v-if="person.remark">({{ person.remark }})</span>
                </div>
                <div class="person-actions">
                  <el-button type="text" icon="el-icon-edit" 
                            v-if="caseInfo.can_edit"
                            @click="handleEditPerson(person)">
                    编辑
                  </el-button>
                  <el-button type="text" icon="el-icon-delete" 
                            v-if="caseInfo.can_edit"
                            @click="handleDeletePerson(person)">
                    删除
                  </el-button>
                </div>
              </div>
              <div class="person-info">
                <div class="info-item">
                  <span class="label">电话：</span>
                  <span class="value">{{ person.phone }}</span>
                </div>
                <div class="info-item">
                  <span class="label">身份证：</span>
                  <span class="value">{{ person.idcard }}</span>
                </div>
                <div class="info-item full-width">
                  <span class="label">地址：</span>
                  <span class="value">{{ person.address }}</span>
                </div>
              </div>

              <div class="info-item-warning">
                <div class="value" v-for="(item, index) in person.othercase" :key="item.id"   @click="viewConflictCase(item)">
                  <div class="warning-item">
                    <span style="font-size: 15px;color: #000;">
                      {{ index + 1 }}： {{ item.title }} ({{ item.id }})
                    </span>
                    <span style="margin-left: 20px;" >
                     ({{ item.client }},{{ item.phone }},{{ item.idCard }})
                    </span>
                    <span style="margin-left: 20px;" v-if="item.type == 1">
                      ({{ item.defendant }},{{ item.defendantPhone }},{{ item.defendantIdCard }})
                    </span>
                    
                  </div>
                </div>
              </div>
              
            </div>
          </div>
        </div>

        <!-- 对方当事人信息 -->
        <div class="person-group">
          <div class="group-title">对方当事人</div>
          <div class="person-list">
            <!-- 案件主对方当事人 -->
            <div class="person-item main-person" v-if="caseInfo.defendant">
              <div class="person-header">
                <div class="person-name">
                  <span class="name">{{ caseInfo.defendant }}</span>
                  <el-tag size="small" type="danger">对方当事人</el-tag>
                </div>
                <div class="person-actions">
                  <!-- <el-button type="text" icon="el-icon-view" @click="viewPerson(caseInfo, true)">查看</el-button> -->
                </div>
              </div>
              <div class="person-info">
                <div class="info-item">
                  <span class="label">电话：</span>
                  <span class="value">{{ caseInfo.defendantPhone }}</span>
                </div>
                <div class="info-item">
                  <span class="label">身份证：</span>
                  <span class="value">{{ caseInfo.defendantIdCard }}</span>
                </div>
                <div class="info-item full-width">
                  <span class="label">地址：</span>
                  <span class="value">{{ caseInfo.defendantAddress }}</span>
                </div>
              </div>

              <div class="info-item-warning">
                <div class="value" v-for="(item, index) in caseInfo.othercase2" :key="item.id"   @click="viewConflictCase(item)">
                  <div class="warning-item">
                    <span style="font-size: 15px;color: #000;">
                    {{ index + 1 }}： {{ item.title }} ({{ item.id }})
                    </span>
                    <span style="margin-left: 20px;" >
                     ({{ item.client }},{{ item.phone }},{{ item.idCard }})
                    </span>
                    <span style="margin-left: 20px;" v-if="item.type == 1">
                      ({{ item.defendant }},{{ item.defendantPhone }},{{ item.defendantIdCard }})
                    </span>
                    <span>
                      <el-tag size="small" type="danger" v-if="item.ctlx == 4">当事人冲突</el-tag>
                      <el-tag size="small" type="warning" v-if="item.ctlx == 5">对方当事人冲突</el-tag>
                      <el-tag size="small" type="info" v-if="item.ctlx == 6">其他当事人冲突</el-tag>
                    </span>
                  </div>
                </div>
              </div>

            </div>

            <!-- 其他对方当事人列表 -->
            <div v-for="person in getPersonsByType(2)" 
                 :key="person.id"
                 class="person-item">
              <div class="person-header">
                <div class="person-name">
                  <span class="name">{{ person.name }}</span>
                  <el-tag size="small" type="info">{{ person.caselink }}</el-tag>
                  <span class="remark" v-if="person.remark">({{ person.remark }})</span>
                </div>
                <div class="person-actions">
                  <el-button type="text" icon="el-icon-edit" 
                            v-if="caseInfo.can_edit"
                            @click="handleEditPerson(person)">
                    编辑
                  </el-button>
                  <el-button type="text" icon="el-icon-delete" 
                            v-if="caseInfo.can_edit"
                            @click="handleDeletePerson(person)">
                    删除
                  </el-button>
                </div>
              </div>
              <div class="person-info">
                <div class="info-item">
                  <span class="label">电话：</span>
                  <span class="value">{{ person.phone }}</span>
                </div>
                <div class="info-item">
                  <span class="label">身份证：</span>
                  <span class="value">{{ person.idcard }}</span>
                </div>
                <div class="info-item full-width">
                  <span class="label">地址：</span>
                  <span class="value">{{ person.address }}</span>
                </div>
              </div>
              <div class="info-item-warning">
                <div class="value" v-for="(item, index) in person.othercase" :key="item.id"   @click="viewConflictCase(item)">
                  <div class="warning-item">
                    <span style="font-size: 15px;color: #000;">
                    {{ index + 1 }}： {{ item.title }} ({{ item.id }})
                    </span>
                    <span style="margin-left: 20px;" >
                     ({{ item.client }},{{ item.phone }},{{ item.idCard }})
                    </span>
                    <span style="margin-left: 20px;" v-if="item.type == 1">
                      ({{ item.defendant }},{{ item.defendantPhone }},{{ item.defendantIdCard }})
                    </span>
                    
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>



      <!-- 冲突预警板块 -->

     
      <!-- <div class="info-section" v-if="caseInfo.othercase && caseInfo.othercase.length">
        <div class="section-header">
          <h3>冲突预警</h3>
          <el-tag type="danger">发现 {{ caseInfo.othercase.length }} 个相关案件</el-tag>
        </div>
        <div class="conflict-list">
          <div v-for="(item, index) in caseInfo.othercase" 
               :key="index"
               class="conflict-item">
            <div class="conflict-content">
              <div class="case-title">
                <span class="title">{{ item.title }}</span>
                <span class="proxy-type" :class="getProxyTypeClass(item.proxyType)">
                  {{ getProxyTypeText(item.proxyType) }}
                </span>
              </div>
              <div class="case-info">
                <span class="info-item">
                  <i class="el-icon-user"></i>
                  双方当事人：{{ item.client }}({{ item.idCard }})、{{ item.defendant }}({{ item.defendantIdCard }})
                </span>

              </div>
              <div class="case-info">
                
                <span class="info-item" v-if="item.others.length">
                  <i class="el-icon-user"></i>
                  其他当事人：{{ item.others.map(o => o.name).join('、') }} ({{ item.others.map(o => o.idcard).join('、') }})
                </span>
                
              </div>
            </div>
            <el-button 
              type="text" 
              size="small"
              class="view-btn"
              @click="viewConflictCase(item)">
              查看案件
            </el-button>
          </div>
        </div>
      </div> -->

      <!-- 人员权限 -->
      <div class="info-section">
        <div class="section-header">
          <h3>人员权限</h3>

          <div class="header-actions">
            <div class="view-switch">
              <span class="switch-label">客户可见：</span>
              <el-switch
                v-model="isclientview"
                :disabled="!caseInfo.can_edit"
                @change="handleClientViewChange"
                active-color="#13ce66"
                inactive-color="#ff4949">
              </el-switch>
            </div>
          </div>
        </div>
        <div class="user-groups">
          <!-- 录入人员 -->
          <div class="user-group">
            <div class="group-title">录入人</div>
            <div class="user-item">
              <el-avatar 
                :size="40" 
                :src="caseInfo.uavatar" 
                icon="el-icon-user">
              </el-avatar>
              <span class="user-name">{{ caseInfo.uname }}</span>
            </div>
          </div>

          <!-- 承办人 -->
          <div class="user-group">
            <div class="group-title">
              <span>承办人</span>
              <el-dropdown 
                v-if="caseInfo.can_edit === 1"
                trigger="click" 
                @command="handleTransferCase"
                :hide-on-click="true">
                <el-button type="text" size="small">
                  <i class="el-icon-share"></i>转让
                </el-button>
                <el-dropdown-menu slot="dropdown" class="viewer-dropdown">
                  <div class="dropdown-header">
                    <el-input
                      v-model="searchLawyer"
                      size="small"
                      placeholder="搜索律师"
                      prefix-icon="el-icon-search"
                      clearable
                      @input="handleSearch">
                    </el-input>
                  </div>
                  <el-dropdown-item 
                    v-for="lawyer in filteredLawyers" 
                    :key="lawyer.uid"
                    :command="lawyer"
                    :disabled="lawyer.uid === caseInfo.handler">
                    <div class="lawyer-item">
                      <el-avatar :size="24" :src="lawyer.avatar" icon="el-icon-user"></el-avatar>
                      <span class="lawyer-name">{{ lawyer.real_name }}</span>
                      <span class="lawyer-disabled" v-if="lawyer.uid === caseInfo.handler">当前承办人</span>
                    </div>
                  </el-dropdown-item>
                  <div v-if="filteredLawyers.length === 0" class="empty-tip">
                    无匹配律师
                  </div>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
            <div class="user-item">
              <el-avatar 
                :size="40" 
                :src="caseInfo.havatar" 
                icon="el-icon-user">
              </el-avatar>
              <span class="user-name">{{ caseInfo.handlername }}</span>
            </div>
          </div>

          <!-- 可查看人员 -->
          <div class="user-group" >
            <div class="group-title">
              <span>可查看人员</span>
              <el-dropdown 
                v-if="caseInfo.can_edit === 1"
                trigger="click" 
                @command="handleAddViewer"
                :hide-on-click="true">
                <el-button type="text" size="small" >
                  <i class="el-icon-plus"></i>添加
                </el-button>
                <el-dropdown-menu slot="dropdown" class="viewer-dropdown">
                  <div class="dropdown-header">
                    <el-input
                      v-model="searchLawyer"
                      size="small"
                      placeholder="搜索律师"
                      prefix-icon="el-icon-search"
                      clearable
                      @input="handleSearch">
                    </el-input>
                  </div>
                  <el-dropdown-item 
                    v-for="lawyer in filteredLawyers" 
                    :key="lawyer.uid"
                    :command="lawyer"
                    :disabled="isLawyerDisabled(lawyer)">
                    <div class="lawyer-item">
                      <el-avatar :size="24" :src="lawyer.avatar" icon="el-icon-user"></el-avatar>
                      <span class="lawyer-name">{{ lawyer.real_name }}</span>
                      <span class="lawyer-disabled" v-if="isLawyerDisabled(lawyer)">已添加</span>
                    </div>
                  </el-dropdown-item>
                  <div v-if="filteredLawyers.length === 0" class="empty-tip">
                    无匹配律师
                  </div>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
            <div class="user-list">
              <div v-for="(user, index) in caseInfo.viewname" 
                   :key="index"
                   class="user-item">
                <el-avatar 
                  :size="40" 
                  :src="user.avatar" 
                  icon="el-icon-user">
                </el-avatar>
                <span class="user-name">{{ user.real_name }}</span>
                <el-button 
                  v-if="caseInfo.can_edit === 1"
                  type="text"
                  class="remove-btn"
                  icon="el-icon-close"
                  @click="handleRemoveViewer(user)">
                </el-button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 流程管理 -->
      <div class="info-section">
        <el-tabs v-model="activeTab">
          <el-tab-pane label="流程管理" name="process">
            <div class="process-container" v-loading="loading">
              <!-- 左侧步骤列表 -->
              <div class="setup-list">
                <el-tabs tab-position="left" v-model="activeSetup">
                  <el-tab-pane 
                    v-for="item in setup"
                    :key="item.id"
                    :label="item.name"
                    :name="item.id">
                    <div class="node-list">
                      <div class="list-header">
                        <h5>{{ item.name }}</h5>
                        <el-tag size="small" :type="getSetupStatusType(item.id)" >
                          {{ getSetupStatusText(item.id) }}
                        </el-tag>
                      </div>
                      
          
                      <div class="nodes">
                        <div v-for="node in nodes" 
                             :key="node.id"
                             class="node-item"
                             :class="{
                               'active': currentNode && actnodeid === node.id,
                               'completed': node.status === 2,
                               'processing': node.status === 1,
                               'pending': node.status === 0
                             }"
                        
                             @click="handleNodeClick(node)">
                          <div class="node-content">
                            <div class="node-header">
                              <span class="node-name">{{ node.name }}</span>
                              <el-tag size="mini" :type="getNodeStatusType(node.status)">
                                {{ getNodeStatusText(node.status) }}
                              </el-tag>
                            </div>
                            <div class="node-info">
                              <span  :style="{color: node.isclientmsg == 1 || node.islawyermsg == 1 ? '#999' : '#e3d3d3'}" >
                                <i class="el-icon-message"></i>
                              </span>
                              <span  :style="{color: node.autoschedule == 1 ? '#999' : '#e3d3d3'}" >
                                <i class="el-icon-bell"></i>
                              </span>
                              <span  :style="{color: node.automsgtime ? '#999' : '#e3d3d3'}" >
                                <i class="el-icon-time"></i>
                                 {{ node.plan_time }}
                              </span> 
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </el-tab-pane>
                </el-tabs>
              </div>
              
              <!-- 右侧节点详情 -->
              <div class="node-detail" v-if="currentNode" v-loading="nodeLoading">
                <div class="detail-header">
                  <h4>{{ currentNode.name }}</h4>
                  <div class="header-actions">
                    <el-button 
                      v-if="currentNode.status !== 2"
                      type="primary" 
                      size="small"
                      @click="completeNode(currentNode.id,1)">
                      完成节点
                    </el-button>

                    <el-button 
                      v-if="currentNode.status === 2"
                      type="danger" 
                      size="small"
                      @click="completeNode(currentNode.id,0)">
                      取消完成
                    </el-button>
                  </div>
                </div>
                
                <!-- 计划时间板块 -->
                <div class="schedule-box" v-if="currentNode.automsgtime">
                  <div class="time-box">
                    <el-row :gutter="16">
                      <el-col :span="6">
                        <div class="time-item">
                          <i class="el-icon-time"></i>
                          <div class="info">
                            <div class="label">节点时间</div>
                            <div class="value">{{ currentNode.automsgtime }}</div>
                          </div>
                          <el-button 
                            v-if="currentNode.status !== 2 && caseInfo.can_edit"
                            type="text"
                            class="edit-btn"
                            @click="setSchedule"
                            :disabled="!caseInfo.can_edit">
                            <i class="el-icon-edit"></i>
                          </el-button> 
                         
                        </div>
                      </el-col>
                      <el-col :span="6">
                        <div class="time-item">
                          <i class="el-icon-date"></i>
                          <div class="info">
                            <div class="label">剩余天数</div>
                            <div class="value" :class="getRemainingDaysClass">{{ getRemainingDays }}</div>
                          </div>
                        </div>
                      </el-col>
                      <el-col :span="6" >
                        <div class="time-item">
                          <i class="el-icon-user"></i>
                          <div class="info">
                            <div class="label">节点负责人</div>
                            <div class="value" >{{ currentNode.nodemangername }}</div>
                          </div>
                        </div>
                      </el-col>
                      <el-col :span="6" >
                        <div class="time-item">
                          <i class="el-icon-bell"></i>
                          <div class="info">
                            <div class="label">客户短信</div>
                            <div class="value" >
                              <span v-if="currentNode.isclientmsg >0">是</span>
                              <span v-else>否</span>
                            </div>
                          </div>
                        </div>
                      </el-col>
                    </el-row>
                  </div>
                </div>
                
                
                
                <!-- 工作记录部分 -->
                <div class="node-worklog">
                  <div class="worklog-title">工作记录</div>
                  <div class="worklog-list">
                    <!-- 工作记录列表项 -->
                    <div class="worklog-item" v-for="(log, index) in currentNode.worklog" :key="index">
                      <div class="log-header">
                        <div class="user-info">
                          <el-avatar :size="32" :src="log.avatar" icon="el-icon-user"></el-avatar>
                          <div class="user-meta">
                            <span class="username">{{ log.uname }}</span>
                            <span class="time">{{ log.time }}</span>
                          </div>
                        </div>
                        <div class="log-actions">
                          <!-- 修改客户可见标签为可点击 -->
                          <el-tag 
                            v-if="log.visible === 1" 
                            size="small" 
                            type="success"
                            class="visible-tag"
                            @click="handleToggleVisible(log)">
                            客户可见
                          </el-tag>
                          <el-button 
                            v-else
                            type="text"
                            class="delete-btn"
                            icon="el-icon-view"
                            @click="handleToggleVisible(log)">
                            
                          </el-button>
                          <!-- 添加删除按钮 -->
                          <el-button 
                            type="text"
                            class="delete-btn"
                            icon="el-icon-delete"
                            @click="handleDeleteLog(log)">
                          </el-button>
                        </div>
                      </div>
                      <div class="log-body">
                        {{ log.content }}
                      </div>
                      <div class="log-files">
                        <div class="file-list">
                          <div v-for="(file, fileIndex) in parseImageValue(log.files)" 
                               :key="fileIndex"
                               class="file-item">
                                <i class="el-icon-document"></i>
                                <span class="file-name" style="font-size: 12px;">{{ file.name }}<span style="font-size: 12px;color: #999;">({{ file.size/1000 }}kb)</span></span> 
                                <el-button 
                                  type="text" 
                                  size="mini"
                                  @click.stop="downloadFile(file)">
                                  下载
                                </el-button>
                            </div>
                          </div>
                      </div>
                    </div>
                    <el-empty 
                      v-if="!currentNode.worklog || !currentNode.worklog.length" 
                      description="暂无工作记录">
                    </el-empty>
                  </div>
                  <!-- 修改工作记录输入框部分 -->
                  <div class="worklog-input">
                    <el-input
                      type="textarea"
                      :rows="3"
                      v-model="newWorkLog"
                      placeholder="请输入工作记录内容..."
                      :maxlength="500"
                      show-word-limit>
                    </el-input>
                    <div class="input-footer">
                      <el-switch
                        v-model="workLogVisible"
                        active-text="客户可见"
                        inactive-text=""
                        class="visibility-switch">
                      </el-switch>
                      <el-upload
                          action="#"
                          :http-request="(params) => handleWorkLogFileUpload(params)"
                          :file-list="workLogFiles"
                          :auto-upload="true"
                          :on-remove="(file) => handleWorkLogRemoveFile(file)">
                          <el-button type="text" size="small" > <i class="el-icon-upload2"></i> 上传附件</el-button>
                        </el-upload>
                      <el-button 
                        type="primary" 
                        size="small"
                        :loading="submittingLog"
                        :disabled="!newWorkLog.trim()"
                        @click="submitWorkLog">
                        提交记录
                      </el-button>
                    </div>
                    
                  </div>
                </div>



                <!-- 节点表单 -->
                <div class="node-form" v-if="currentNode.form && currentNode.form.length">
                  <div class="form-title">
                    节点表单 
                    <span v-if="currentNode.formname !== ''">({{ currentNode.formname }})</span>
                    <button type="text" class="print-btn" @click="printForm" v-if="currentNode.printid"><i class="el-icon-printer"></i>打印</button>
                  </div>
                  <!-- 已完成状态：只读展示 -->
                  <!-- <template v-if="currentNode.status === 2">
                    <div class="form-readonly">
                      <div v-for="field in currentNode.form" 
                           :key="field.key"
                           class="form-item">
                        <div class="form-label">{{ field.label }}：</div>
                        <div class="form-value">
                   
                          <template v-if="field.type === 'switch'">
                            <el-tag size="small" :type="field.value ? 'success' : 'info'">
                              {{ field.value ? '是' : '否' }}
                            </el-tag>
                          </template>
                         
                          <template v-else-if="field.type === 'select'">
                            {{ field.value }}
                          </template>
              
                          <template v-else-if="field.type === 'image'">
                            <div class="image-list">
                              <div v-for="(img, imgIndex) in parseImageValue(field.value)" 
                                   :key="imgIndex" 
                                   class="image-item">
                                <el-image 
                                  :src="img.url" 
                                  :preview-src-list="getPreviewList(field.value)"
                                  fit="cover">
                                </el-image>
                              </div>
                            </div>
                          </template>
                       
                          <template v-else-if="field.type === 'upload'">
                            <div class="file-list">
                              <div v-for="(file, fileIndex) in parseImageValue(field.value)" 
                                   :key="fileIndex"
                                   class="file-item">
                                <i class="el-icon-document"></i>
                                <span class="file-name">{{ file.name }}<span style="font-size: 12px;color: #999;">({{ file.size/1000 }}kb)</span></span> 
                                <el-button 
                                  type="text" 
                                  size="mini"
                                  @click.stop="downloadFile(file)">
                                  下载
                                </el-button>
                              </div>
                            </div>
                          </template>
                    
                          <template v-else>
                            {{ field.value || '-' }}
                          </template>
                        </div>
                      </div>
                    </div>
                  </template> -->
                  
                  <!-- 未完成状态：可编辑表单 -->
                  <div class="form-edit">
                    <el-form 
                      :model="formModel" 
                      label-width="100px" 
                      ref="nodeForm"
                      :validate-on-rule-change="false">
                      <el-form-item 
                        v-for="(field, index) in currentNode.form"
                        :key="field.key"
                        :label="field.label"
                        :prop="field.key"
                        :rules="field.required ? [{
                          required: true,
                          message: '请填写' + field.label,
                          trigger: ['blur', 'change']
                        }] : []">
                        <!-- 文本输入 -->
                        <el-input 
                          v-if="field.type === 'text'"
                          v-model="formModel[field.key]"
                          :placeholder="field.placeholder">
                        </el-input>
                        
                        <!-- 多行文本 -->
                        <el-input 
                          v-if="field.type === 'textarea'"
                          type="textarea"
                          :rows="4"
                          v-model="formModel[field.key]"
                          :placeholder="field.placeholder">
                        </el-input>
                        
                        <!-- 开关 -->
                        <el-switch
                          v-if="field.type === 'switch'"
                          v-model="formModel[field.key]">
                        </el-switch>
                        
                        <!-- 下拉选择 -->
                        <el-select
                          v-if="field.type === 'select'"
                          v-model="formModel[field.key]"
                          :placeholder="field.placeholder">
                          <el-option
                            v-for="option in field.options"
                            :key="option.value"
                            :label="option.label"
                            :value="option.value">
                          </el-option>
                        </el-select>
                        
                        <!-- 图片上传 -->
                        <template v-if="field.type === 'image'">
                          <el-upload
                            action="#"
                            list-type="picture-card"
                            :http-request="(params) => handleImageUpload(params, field)"
                            :file-list="formModel[field.key] || []"
                            :before-upload="(file) => beforeImageUpload(file, field)"
                            :accept="getAcceptTypes(field.filetype)"
                            :auto-upload="true"
                            :on-remove="(file) => handleRemoveFile(field, file)">
                            <i class="el-icon-plus"></i>
                            <div slot="tip" class="el-upload__tip">
                              只能上传 {{ field.filetype }} 格式图片，且不超过 {{ field.maxsize }}MB
                            </div>
                          </el-upload>
                        </template>
                        
                        <!-- 文件上传 -->
                        <el-upload
                          v-if="field.type === 'upload'"
                          action="#"
                          :http-request="(params) => handleFileUpload(params, field)"
                          :file-list="formModel[field.key] || []"
                          :before-upload="(file) => beforeFileUpload(file, field)"
                          :accept="getAcceptTypes(field.filetype)"
                          :auto-upload="true"
                          :on-remove="(file) => handleRemoveFile(field, file)">
                          <el-button size="small" type="primary">点击上传</el-button>
                          <div slot="tip" class="el-upload__tip">
                            支持 {{ field.filetype }} 格式文件，单个文件不超过 {{ field.maxsize }}MB
                          </div>
                        </el-upload>
                      </el-form-item>
                    </el-form>
                    
                    <div class="form-footer">
                      <el-button 
                        type="primary" 
                        :loading="submittingForm"
                        @click="submitNodeForm">
                        提交表单
                      </el-button>
                    </div>
                  </div>
                </div>
                
                <!-- 添加用户表单模块 -->
                <div class="client-form" v-if="currentNode.clientform && currentNode.clientform.length">
                  <div class="form-title">
                    <span>用户表单</span>
                    <el-button 
                      v-if="caseInfo.can_edit === 1" 
                      type="text" 
                      size="small"
                      class="clear-btn"
                      @click="handleClearClientForm">
                      <i class="el-icon-delete"></i>
                      清除表单
                    </el-button>
                  </div>
                  
                  <div class="form-content">
                    <div v-for="field in currentNode.clientform" 
                         :key="field.key"
                         class="form-item">
                      <div class="form-label">{{ field.label }}：</div>
                      <div class="form-value">
                        <!-- 开关类型 -->
                        <template v-if="field.type === 'switch'">
                          <el-tag size="small" :type="field.value ? 'success' : 'info'">
                            {{ field.value ? '是' : '否' }}
                          </el-tag>
                        </template>
                        
                        <!-- 下拉选择 -->
                        <template v-else-if="field.type === 'select'">
                          {{ field.value }}
                        </template>
                        
                        <!-- 图片类型 -->
                        <template v-else-if="field.type === 'image'">
                          <div class="image-list">
                            <div v-for="(img, imgIndex) in parseImageValue(field.value)" 
                                 :key="imgIndex" 
                                 class="image-item">
                              <el-image 
                                :src="img.url" 
                                :preview-src-list="getPreviewList(field.value)"
                                fit="cover">
                              </el-image>
                            </div>
                          </div>
                        </template>
                        
                        <!-- 其他类型 -->
                        <template v-else>
                          {{ field.value || '-' }}
                        </template>
                      </div>
                    </div>
                  </div>
                </div>
                
                <!-- 消息模板 -->
                <div class="node-notice">
                  <div class="notice-title">消息模板</div>
                  <div class="notice-items">
                    <div class="notice-item" v-if="currentNode.islawyermsg">
                      <div class="notice-header">
                        <span class="label">律师通知内容：</span>
                      </div>
                      <div class="content">{{ currentNode.lawyermsgmodel }}</div>
                      <el-button 
                        type="primary" 
                        size="small"
                        class="send-btn"
                        @click="sendNodeMessage('lawyer')">
                        发送消息
                      </el-button>
                    </div>
                    <div class="notice-item" v-if="currentNode.isclientmsg">
                      <div class="notice-header">
                        <span class="label">客户通知内容：</span>
                      </div>
                      <div class="content">{{ currentNode.clientmsgmodel }}</div>
                      <el-button 
                        type="primary" 
                        size="small"
                        class="send-btn"
                        @click="sendNodeMessage('client')">
                        发送消息
                      </el-button>
                    </div>
                  </div>
                  
                  <!-- 添加时间编辑对话框 -->
                  <el-dialog
                    title="修改计划时间"
                    :visible.sync="timeDialogVisible"
                    width="400px"
                    :close-on-click-modal="false"
  custom-class="time-edit-dialog"
                    :modal-append-to-body="false"
                    append-to-body>
                    <el-form :model="timeForm" ref="timeForm" label-width="0">
                      <el-form-item>
                        <el-date-picker
                          v-model="timeForm.datetime"
                          type="datetime"
                          placeholder="选择日期时间"
                          value-format="yyyy-MM-dd HH:mm"
                          style="width: 100%">
                        </el-date-picker>
                      </el-form-item>
                    </el-form>
                    <div slot="footer" class="dialog-footer">
                      <el-button @click="timeDialogVisible = false">取 消</el-button>
                      <el-button type="primary" @click="submitEditTime" :loading="submittingTime">确 定</el-button>
                    </div>
                  </el-dialog>
                  
                  <!-- 消息记录列表 -->
                  <div class="message-list" v-if="currentNode.msglist && currentNode.msglist.length">
                    <div class="list-title">消息记录</div>
                    <div class="message-items">
                      <div v-for="msg in currentNode.msglist" 
                           :key="msg.id"
                           class="message-item">
                        <div class="msg-header">
                          <span class="msg-type">
                            {{ msg.type === 'lawyer' ? '律师通知' : '客户通知' }}
                          </span>
                          <span class="msg-time">{{ msg.time }}</span>
                        </div>
                        <div class="msg-content">{{ msg.content }}</div>
                        <div class="msg-phone">接收号码：{{ msg.phone }}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              
              <!-- 未选择节点时的提示 -->
              <div class="node-detail empty-state" v-else>
                <el-empty description="请选择要查看的节点"></el-empty>
              </div>
            </div>
          </el-tab-pane>
          
          <el-tab-pane label="工作记录" name="worklog">
            <div class="worklog-container" v-loading="workLogLoading">
              <div class="worklog-list">
                <div v-for="(log, index) in workLogs" 
                     :key="index"
                     class="worklog-item">
                  <div class="log-header">
                    <div class="user-info">
                      <el-avatar :size="32" :src="log.avatar" icon="el-icon-user"></el-avatar>
                      <div class="user-meta">
                        <span class="username">{{ log.uname }}</span>
                        <span class="time">{{ log.time }}</span>
                      </div>
                    </div>
                    <div>
                      <span  style="font-size: 12px;color: #999;">{{ log.nodename }}(ID{{ log.id }} )</span> 
                    </div> 
                    <div class="log-actions">
                      <el-tag 
                        v-if="log.visible === 1" 
                        size="small" 
                        type="success"
                       >
                        客户可见
                      </el-tag>
                    </div>
                  </div>
                  <div class="log-content">{{ log.content }}</div>
                  <div class="log-files">
                        <div class="file-list">
                          <div v-for="(file, fileIndex) in parseImageValue(log.files)" 
                               :key="fileIndex"
                               class="file-item">
                                <i class="el-icon-document"></i>
                                <span class="file-name" style="font-size: 12px;">{{ file.name }}<span style="font-size: 12px;color: #999;">({{ file.size/1000 }}kb)</span></span> 
                                <el-button 
                                  type="text" 
                                  size="mini"
                                  @click.stop="downloadFile(file)">
                                  下载
                            </el-button>
                        </div>
                      </div>
                  </div>
                </div>
                <el-empty 
                  v-if="!workLogs.length" 
                  description="暂无工作记录">
                </el-empty>
              </div>
            </div>
          </el-tab-pane>
          
          <el-tab-pane label="消息记录" name="message">
            <!-- <div class="tab-header">
              <h5>消息记录</h5>
              <el-button 
                v-if="caseInfo.can_edit"
                type="text" 
                icon="el-icon-message"
                @click="sendMessage">
                发送消息
              </el-button>
            </div> -->
            <div class="message-list">
              <div v-for="(msg, index) in messages" 
                   :key="index"
                   class="message-item">
                <div class="msg-meta">
                  <span class="msg-type">{{ getMsgTypeText(msg.type) }}</span>
                  <span class="msg-time">{{ msg.time }}</span>
                  <el-tag 
                    size="mini" 
                    :type="msg.status === 1 ? 'success' : 'danger'">
                    {{ msg.status === 1 ? '发送成功' : '发送失败' }}
                  </el-tag>
                </div>
                <div class="msg-content">{{ msg.content }}</div>
                <div class="msg-receiver">接收人：{{ msg.phone }}</div>
              </div>
            </div>
          </el-tab-pane>
          
          <el-tab-pane label="操作日志" name="permission">
            <!-- <div class="tab-header">
              <h5></h5>
              <el-date-picker
                v-model="permissionDateRange"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                size="small"
                style="width: 260px"
                @change="handlePermissionDateChange">
              </el-date-picker>
            </div> -->
            <el-table :data="permissionLogs" style="width: 100%">
              <el-table-column prop="add_time" label="时间" width="180"></el-table-column>
              <el-table-column prop="uname" label="操作人" width="120"></el-table-column>
              <el-table-column prop="action" label="操作类型" width="120">
                <template slot-scope="scope">
                  <el-tag :type="getActionTagType(scope.row.type)" size="small">
                    {{ scope.row.type }}
                  </el-tag>
                </template>
              </el-table-column>
              <el-table-column prop="content" label="操作内容"></el-table-column>
            </el-table>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>

    <!-- 编辑案件对话框 -->
    <el-dialog
      title="编辑案件"
      :visible.sync="editDialogVisible"
      width="850px"
      :close-on-click-modal="false"
      :before-close="handleDialogClose">
      <el-form :model="editForm" :rules="formRules" ref="editForm" label-width="100px">
        <!-- 基本信息 -->
        <div class="form-section">
          <div class="section-title">基本信息</div>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="案件名称" prop="title">
                <el-input v-model="editForm.title" placeholder="请输入案件名称"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="案件类型" prop="type">
                <el-select v-model="editForm.type" placeholder="请选择案件类型">
                  <el-option v-for="item in cateOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="案号" prop="caseNumber">
                <el-input v-model="editForm.caseNumber" placeholder="请输入案号"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="承办人" prop="handler">
                <el-select v-model="editForm.handler" placeholder="请选择承办人">
                  <el-option
                    v-for="item in handlers"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <!-- 修改编辑表单中的代理类型部分 -->
          <el-form-item label="代理类型" prop="proxyType">
            <el-select v-model="editForm.proxyType" placeholder="请选择代理类型">
              <el-option label="起诉" value="1"></el-option>
              <el-option label="辩护" value="2"></el-option>
              <el-option label="调解" value="3"></el-option>
              <el-option label="应诉" value="4"></el-option>
            </el-select>
          </el-form-item>
        </div>

        <!-- 当事人信息 -->
        <div class="form-section">
          <div class="section-title">当事人信息</div>
          <div class="party-info">
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="当事人" prop="client">
                  <el-input v-model="editForm.client" placeholder="请输入当事人姓名/单位名称"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="联系电话" prop="phone">
                  <el-input v-model="editForm.phone" placeholder="请输入联系电话"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            
            <el-form-item label="身份证号" prop="idCard">
              <el-input v-model="editForm.idCard" placeholder="请输入身份证号/统一社会信用代码"></el-input>
            </el-form-item>
            
            <el-form-item label="联系地址" prop="address">
              <el-input v-model="editForm.address" placeholder="请输入联系地址"></el-input>
            </el-form-item>
          </div>

        </div>

         <!-- 对方当事人信息 -->
         <div class="form-section">
          <div class="section-title">对方当事人信息</div>         
          <div class="party-info">
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="对方当事人" prop="defendant">
                  <el-input v-model="editForm.defendant" placeholder="请输入对方当事人姓名/单位名称"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="联系电话" prop="defendantPhone">
                  <el-input v-model="editForm.defendantPhone" placeholder="请输入联系电话"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            
            <el-form-item label="身份证号" prop="defendantIdCard">
              <el-input v-model="editForm.defendantIdCard" placeholder="请输入身份证号/统一社会信用代码"></el-input>
            </el-form-item>
            
            <el-form-item label="联系地址" prop="defendantAddress">
              <el-input v-model="editForm.defendantAddress" placeholder="请输入联系地址"></el-input>
            </el-form-item>
          </div>
        </div>

        <!-- 案件描述 -->
        <div class="form-section">
          <div class="section-title">案件描述</div>
          <el-form-item label="案件描述" prop="description">
            <el-input
              type="textarea"
              :rows="4"
              v-model="editForm.description"
              placeholder="请输入案件描述">
            </el-input>
          </el-form-item>
          
          <el-form-item label="备注" prop="remark">
            <el-input
              type="textarea"
              :rows="3"
              v-model="editForm.remark"
              placeholder="请输入备注信息">
            </el-input>
          </el-form-item>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleDialogClose">取 消</el-button>
        <el-button type="primary" @click="submitEdit" :loading="submitting">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 在 template 最后添加人员表单对话框 -->
    <el-dialog
      :title="personForm.id ? '编辑人员' : '添加人员'"
      :visible.sync="personDialogVisible"
      width="600px"
      :close-on-click-modal="false"
      @closed="resetPersonForm">
      <el-form 
        :model="personForm" 
        :rules="personRules" 
        ref="personForm" 
        label-width="100px">
        <el-form-item label="人员类型" prop="type">
          <el-radio-group v-model="personForm.type">
            <el-radio :label="1">我方当事人</el-radio>
            <el-radio :label="2">对方当事人</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="姓名" prop="name">
          <el-input v-model="personForm.name" placeholder="请输入姓名/单位名称"></el-input>
        </el-form-item>

        <el-form-item label="联系电话" prop="phone">
          <el-input v-model="personForm.phone" placeholder="请输入联系电话"></el-input>
        </el-form-item>

        <el-form-item label="身份证号" prop="idcard">
          <el-input v-model="personForm.idcard" placeholder="请输入身份证号/统一社会信用代码"></el-input>
        </el-form-item>

        <el-form-item label="联系地址" prop="address">
          <el-input v-model="personForm.address" placeholder="请输入联系地址"></el-input>
        </el-form-item>

        <!-- 修改案件关系表单项 -->
        <el-form-item label="案件关系" prop="caselink">
          <el-input v-model="personForm.caselink" placeholder="请输入与案件的关系,如:共同原告、第二被告等"></el-input>
          <div class="quick-input-buttons">
            <el-button 
              v-for="relation in quickRelations" 
              :key="relation"
              type="text"
              size="small"
              @click="quickInputRelation(relation)">
              {{ relation }}
            </el-button>
          </div>
        </el-form-item>

        <!-- 修改备注表单项 -->
        <el-form-item label="备注" prop="remark">
          <el-input 
            type="textarea" 
            :rows="3"
            v-model="personForm.remark" 
            placeholder="请输入备注信息">
          </el-input>
          <div class="quick-input-buttons relation-buttons">
            <el-button 
              v-for="relation in relationTypes" 
              :key="relation"
              type="text"
              size="small"
              @click="quickInputRemark(relation)">
              {{ relation }}
            </el-button>
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="personDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitPersonForm" :loading="submittingPerson">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Header from '@/components/Header.vue'
import caseApi from '@/api/case'
import { mapState } from 'vuex'  
import { qxjiean } from '@/api/case'

export default {
  name: "CaseInfo",
  components: {
    Header
  },
  data() {
    return {
      workLogFiles: [], // 工作记录附件列表
      isclientview:false,
      actnodeid:0,
      firstLoad: false,
      setup: [], // 清空默认数据
      nodes: [], // 清空默认数据
      loading: false,
      caseId: this.$route.query.id,
      caseInfo: {},
      editDialogVisible: false,
      submitting: false,
      editForm: {
        defendant: '',      // 被告姓名
        defendantPhone: '', // 被告电话
        defendantIdCard: '',// 被告身份证
        defendantAddress: '',// 被告地址
      },
      cateOptions: [],
      lawyers: [],
      handlers: [],
      formRules: {
        title: [
          { required: true, message: '请输入案件名称', trigger: 'blur' },
          { min: 2, max: 100, message: '长度在 2 到 100 个字符', trigger: 'blur' }
        ],
        type: [
          { required: true, message: '请选择案件类型', trigger: 'change' }
        ],
        handler: [
          { required: true, message: '请选择承办人', trigger: 'change' }
        ],
        client: [
          { required: true, message: '请输入当事人姓名/单位名称', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请输入当事人电话', trigger: 'blur' },
        ],
        idCard: [
          { required: true, message: '请输入当事人身份证号/统一社会信用代码', trigger: 'blur' },
        ],
        
        // defendant: [
        //   { required: true, message: '请输入对方当事人姓名/单位名称', trigger: 'blur' }
        // ],
        // defendantPhone: [
        //   { required: true, message: '请输入对方当事人电话', trigger: 'blur' },
        // ],
        // defendantIdCard: [
        //   { required: true, message: '请输入对方当事人身份证号/统一社会信用代码', trigger: 'blur' },
        // ],
        
        proxyType: [
          { required: true, message: '请选择代理类型', trigger: 'change' }
        ]
      },
      activeTab: 'process',
      workLogs: [],
      messages: [],
      permissionLogs: [],
      permissionDateRange: '',
      searchLawyer: '',
      activeSetup: '1',
      currentNode: null,
      newWorkLog: '',  // 新工作记录内容
      submittingLog: false,  // 提交状态
      submittingForm: false, // 表单提交状态
      workLogVisible: false, 
      nodeLoading: false, 
      timeDialogVisible: false,
      timeForm: {
        datetime: ''
      },
      submittingTime: false,
      workLogLoading: false, // 加载状态
      workLogForm: {
        content: '', // 工作记录内容
        visible: false // 是否客户可见
      },
      workLogDialogVisible: false, // 添加工作记录对话框
      submittingWorkLog: false, // 提交工作记录状态
      formModel: {},  // 添加表单数据对象
      persons: [], // 存储人员列表
      personDialogVisible: false, // 人员表单对话框显示状态
      submittingPerson: false, // 提交状态
      personForm: {
        type: 1,
        name: '',
        phone: '',
        idcard: '',
        address: '',
        caselink: '',
        remark: '',
        caseid: this.caseId
      },
      personRules: {
        type: [
          { required: true, message: '请选择人员类型', trigger: 'change' }
        ],
        name: [
          { required: true, message: '请输入姓名', trigger: 'blur' },
          { min: 2, max: 200, message: '长度在 2 到 200 个字符', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请输入联系电话', trigger: 'blur' },
          // { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号码', trigger: 'blur' }
        ],
        idcard: [
          { required: true, message: '请输入身份证号', trigger: 'blur' },
          // { pattern: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/, message: '请输入正确的身份证号', trigger: 'blur' }
        ],
        address: [
          { required: true, message: '请输入联系地址', trigger: 'blur' }
        ],
        caselink: [
          { required: true, message: '请输入与案件的关系', trigger: 'blur' }
        ]
      },
      quickRelations: ['原告','被告','第三人','代理人','委托人', '共同原告', '共同被告', '复议机关', '第一被告','第二被告', '第三被告'],
      relationTypes: [
        '父亲',
        '母亲',
        '儿子',
        '女儿',
        '配偶',
        '兄弟',
        '姐妹',
        '祖父',
        '祖母',
        '外祖父',
        '外祖母',
        '孙子',
        '孙女',
        '叔叔',
        '阿姨',
        '舅舅',
        '姑姑',
        '表兄弟',
        '表姐妹',
        '堂兄弟',
        '堂姐妹',
        '同事',
        '上级',
        '下属',
        '朋友',
        '邻居',
        '合伙人',
        '债权人',
        '债务人',
        '雇主',
        '雇员',
        '房东',
        '房客',
        '供应商',
        '客户'
      ]
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.userInfo
    }),
    getStatusType() {
      const types = {
        0: 'info',
        1: 'warning',
        5: 'success'
      }
      return types[this.caseInfo.status] || 'info'
    },
    getStatusText() {
      const texts = {
        0: '已删除',
        1: '进行中',
        2: '已取消',
        5: '已结案'
      }
      return texts[this.caseInfo.status] || '未知'
    },
    filteredLawyers() {
      let lawyers = this.lawyers || []
      
      if (this.searchLawyer) {
        const keyword = this.searchLawyer.toLowerCase()
        lawyers = lawyers.filter(lawyer => 
          lawyer.real_name.toLowerCase().includes(keyword)
        )
      }
      
      return lawyers
    },
    // 计算剩余天数
    getRemainingDays() {
      if (!this.currentNode || !this.currentNode.automsgtime) return '未设置'
      
      const now = new Date()
      const targetDate = new Date(this.currentNode.automsgtime)
      const diffTime = targetDate - now
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24))
      
      if (diffDays < 0) return '已过期'
      if (diffDays === 0) return '今天'
      return `${diffDays}天`
    },
    
    // 根据剩余天数返回样式类名
    getRemainingDaysClass() {
      if (!this.currentNode || !this.currentNode.automsgtime) return ''
      
      const days = this.getRemainingDays
      if (days === '已过期') return 'expired'
      if (days === '今天') return 'today'
      
      const numDays = parseInt(days)
      if (numDays <= 3) return 'warning'
      return 'normal'
    }
  },
  async created() {
    await this.fetchCaseInfo()
    await this.fetchSetupAndNodes() // 获取步骤列表和第一个步骤的节点
    await this.fetchCategories()
    await this.fetchHandlers()
    // await this.fetchPersons() // 获取人员列表
  },
  methods: {
    async handleClientViewChange(value) {
      const res = await caseApi.updateClientView({caseid: this.caseId, isclientview: value})
      await this.fetchCaseInfo()
    },


    // 打印
    printForm(){
      window.open(`${window.location.origin}/printform?id=${this.currentNode.id}`, '_blank')
    },


    // 设置日程 新窗口打开  携带案件id  
    setSchedule(){  
      this.$router.push(`/setschedule?id=${this.caseId}`)
    },

    goBack() {
      this.$router.push('/cases')
    },
    async fetchCaseInfo() {
      try {
        const response = await caseApi.getCaseInfo({ id: this.caseId })
        if (response.status === 200) {
          this.caseInfo = response.data.info;
          this.permissionLogs = response.data.logs;
          if (response.data.info.isclientview == 1) {
            this.isclientview = true
          }else{
            this.isclientview = false
          }
          console.log(this.isclientview);
        }
        if (response.status === 400) {
          this.$message.error('无权查看该案件')
          this.goBack()
        }
      } catch (error) {
        this.$message.error('获取案件信息失败')
      }
    },
    goBack() {
      this.$router.push('/cases')
    },
    // 获取案件分类
    async fetchCategories() {
      try {
        const response = await caseApi.getCaseCate()
        if (response.status === 200) {
          this.cateOptions = response.data.map(item => ({
            value: item.id,
            label: item.name
          }))
          // 除第一个"全部案件"选项
          this.cateOptions.splice(0, 1)
        }
      } catch (error) {
        console.error('获取案件分类失败:', error)
      }
    },
    // 获取律师列表
    async fetchHandlers() {
      try {
        const response = await caseApi.getLawyerList()
        if (response.status === 200) {
          this.lawyers = response.data
          this.handlers = response.data.map(item => ({
            value: item.uid,
            label: item.real_name
          }))
        }
      } catch (error) {
        console.error('获取律师列表失败:', error)
      }
    },
    // 处理编辑按钮点击
    handleEdit() {
      if (!this.caseInfo.can_edit) {
        this.$message.warning('您没有编辑权限')
        return
      }
      
      // 复制案件信息到编辑表单，确保代理类型是字符串
      this.editForm = {
        ...this.caseInfo,
        proxyType: this.caseInfo.proxyType ? this.caseInfo.proxyType.toString() : ''
      }
      
      this.editDialogVisible = true
      this.$nextTick(() => {
        this.$refs.editForm && this.$refs.editForm.clearValidate()
      })
    },
    // 处理编辑框关闭
    handleDialogClose() {
      this.editDialogVisible = false
      // this.$confirm('确认关闭？未保存的修改将会丢失', '提示', {
      //   confirmButtonText: '确定',
      //   cancelButtonText: '取消',
      //   type: 'warning'
      // }).then(() => {
      //   this.editDialogVisible = false
      // }).catch(() => {})
    },
    // 提交编辑
    async submitEdit() {

      if(this.editForm.type == '1'){
        if(this.editForm.defendant == ''){
          this.$message.error('请输入对方当事人姓名/单位名称')
          return
        }
        if(this.editForm.defendantPhone == ''){
          this.$message.error('请输入对方当事人电话')
          return
        }
        if(this.editForm.defendantIdCard == ''){
          this.$message.error('请输入对方当事人身份证号/统一社会信用代码')
          return
        }
      }


      try {
        await this.$refs.editForm.validate()
        this.submitting = true
        console.log(this.editForm)
        // return;
        const response = await caseApi.updateCase({
          id: this.caseId,
          formdata:this.editForm
        })
        
        if (response.status === 200) {
          console.log(response);
          this.$message.success('更新成功')
          this.editDialogVisible = false
          await this.fetchCaseInfo()  // 重新获取案件信息
        } else {
          this.$message.error(response.message || '更新失败')
        }
      } catch (error) {
        console.error('更新案件失败:', error)
        this.$message.error('更新失败，请重试')
      } finally {
        this.submitting = false
      }
    },
    // 处理更多操作
    handleCommand(command) {
      switch (command) {
        case 'complete':
          if (this.caseInfo.status === 5) {
            this.$message.warning('案件已完成')
            return
          }
          this.handleComplete()
          break
        case 'cancelcomplete':
          if (this.caseInfo.status === 1) {
            this.$message.warning('案件已取消结案')
            return
          }
          this.handleCancelComplete()
          break
        case 'cancel':
          if (this.caseInfo.status === 2) {
            this.$message.warning('案件已取消')
            return
          }
          this.handleCancel()
          break
        case 'delete':
          if (this.caseInfo.isadmin !== 1) {
            this.$message.warning('仅管理员可删除案件')
            return
          }
          this.handleDelete()
          break
      }
    },

    // 处理取消结案
    handleCancelComplete() {

      qxjiean({id:this.caseId}).then(res => {
        if (res.status === 200) {
          this.$message.success('案件已取消结案')
          this.fetchCaseInfo() // 重新获取案件信息
        } else {
          this.$message.error('操作失败')
        }
      })

    },

    // 处理完成案件
    async handleComplete() {
      try {
        await this.$confirm('确认将案件标记为已结案？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        
        const response = await caseApi.completeCase({
          id: this.caseId
        })
        
        if (response.status === 200) {
          this.$message.success('案件已完成')
          await this.fetchCaseInfo() // 重新获取案件信息
        } else {
          this.$message.error(response.message || '操作失败')
        }
      } catch (error) {
        if (error !== 'cancel') {
          console.error('完成案件失败:', error)
          this.$message.error('操作失败，请重试')
        }
      }
    },
    // 处理取消案件
    async handleCancel() {
     // 实现取消案件的逻辑
     try {
      await this.$confirm('确认取消该案件？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })

      const response = await caseApi.cancelCase({
        id: this.caseId
      })

      if (response.status === 200) {
        this.$message.success('案件已取消')
        await this.fetchCaseInfo() // 重新获取案件信息
      } else {
        this.$message.error(response.message || '操作失败')
      }
     } catch (error) {
       if (error !== 'cancel') {
          console.error('取消案件失败:', error)
          this.$message.error('操作失败，请重试')
        }
     }
    },
    // 处理删除操作
    async handleDelete() {
      try {
        await this.$confirm('确认删除该案件？此操作不可恢复', '警告', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        
        const response = await caseApi.deleteCase({
          id: this.caseId
        })
        
        if (response.status === 200) {
          this.$message.success('删除成功')
          this.$router.push('/cases')
        } else {
          this.$message.error(response.message || '删除失败')
        }
      } catch (error) {
        if (error !== 'cancel') {
          console.error('删除案件失败:', error)
          this.$message.error('删除失败，请重试')
        }
      }
    },
    // 添加流程
    addProcess() {
      // 实现添加流程的逻辑
    },
    
    // 添加工作记
    addWorkLog() {
      this.workLogForm = {
        content: '',
        visible: false
      }
      this.workLogDialogVisible = true
    },
    
    // 发送消息
    sendMessage() {
      // 实现发送消息的逻辑
    },
    
    // 获取消息类型文本
    getMsgTypeText(type) {
      const types = {
        lawyer: '律师',
        client: '客户',
        wechat: '微信'
      }
      return types[type] || '其他'
    },
    
    // 获取操作类型标签样式
    getActionTagType(action) {
      const types = {
        'view': 'success',
        'edi': 'warning',
        'del': 'danger',
      }
      return types[action] || 'info'
    },
    
    // 处理权限日志日期变化
    handlePermissionDateChange(val) {
      // 实现日期筛选逻辑
    },
    
    // 处理权限设置
    handlePermissionSetting() {
      // 这里实现权限设置的逻辑
      this.$message.info('权限设置功能待实')
    },
    
    // 改判断律师是否已添加的方法
    isLawyerDisabled(lawyer) {
      // 检查是否是当前承办人
      if (lawyer.uid === this.caseInfo.handler) {
        return true
      }
      
      // 检查是否是录入人
      if (lawyer.uid === this.caseInfo.uid) {
        return true
      }
      
      // 检查是否已在可查看列表中
      if (this.caseInfo.viewuid) {
        const viewUids = this.caseInfo.viewuid.split(',').map(id => parseInt(id))
        return viewUids.includes(lawyer.uid)
      }
      
      return false
    },
    
    // 处理搜索输入
    handleSearch() {
      // 可以添加防抖处理
    },
    
    // 修改添加查看人员的方法
    async handleAddViewer(lawyer) {
      try {
        // 获取当前有查看人员�� uid
        let currentUids = []
        if (this.caseInfo.viewuid) {
          currentUids = this.caseInfo.viewuid.split(',').map(id => parseInt(id))
        }
        
        // 检查是否已存在
        if (currentUids.includes(lawyer.uid)) {
          this.$message.warning('该用户已在可查看列表中')
          return
        }
        
        // 添加新的 uid
        const newUids = [...currentUids, lawyer.uid]
        
        // 转换为字符串格式
        const viewUids = newUids.join(',')
        
        // 调用添加接口
        const response = await caseApi.addCaseViewer({
          case_id: this.caseId,
          viewuid: viewUids
        })
        
        if (response.status === 200) {
          this.$message.success('添加成功')
          await this.fetchCaseInfo() // 重新获取案件信息
        } else {
          this.$message.error(response.message || '添加失败')
        }
      } catch (error) {
        console.error('添加查看人员失败:', error)
        this.$message.error('添加失败，请重试')
      }
    },
    
    // 修改移除查看人员的方法
    async handleRemoveViewer(user) {
      this.$confirm(`确认移除 ${user.real_name} 的查看权限？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          // 获取除了要移除的用户之外的所有 uid
          const newUids = this.caseInfo.viewname
            .filter(viewer => viewer.uid !== user.uid)
            .map(viewer => viewer.uid)
            .join(',');
          
          console.log(newUids)

          // 调用接口更新查看人员
          const response = await caseApi.addCaseViewer({
            case_id: this.caseId,
            viewuid: newUids || ''  // 如果没有其他查看人员，发送空字符串
          })
          
          if (response.status === 200) {
            this.$message.success('移除成功')
            await this.fetchCaseInfo() // 重新获取案件信息
          } else {
            this.$message.error(response.message || '移除失败')
          }
        } catch (error) {
          console.error('移除查看人员失败:', error)
          this.$message.error('移除失败，请重试')
        }
      }).catch(() => {})
    },

    // 转让案件 // 处理案件转让
    async handleTransferCase(lawyer) {
      try {
        await this.$confirm(
          `确认将案件转让给 ${lawyer.real_name}？`,
          '转让确认',
          {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }
        )
        
        const response = await caseApi.updateCaseHandler({
          id: this.caseId,
          handler: lawyer.uid
        })
        
        if (response.status === 200) {
          this.$message.success('转让成功')
          await this.fetchCaseInfo() // 重新获取案件信息
        } else {
          this.$message.error(response.message || '转让失败')
        }
      } catch (error) {
        if (error !== 'cancel') {
          console.error('案件转让失败:', error)
          this.$message.error('转让失败，请重试')
        }
      }
    },
    // 获取设置状态类型
    getSetupStatusType(setupId) {
      // 获取该���段的所有节点
      const nodes = this.nodes.filter(node => node.setupid === setupId)
      // 获取已完成的节点数
      const completedNodes = nodes.filter(node => node.status === 2).length
      // ���节点数
      const totalNodes = nodes.length
      
      if (completedNodes === totalNodes) return 'success'  // 全部完成
      if (completedNodes === 0) return 'info'             // 未开始
      return 'warning'                                    // 进行中
    },
    // 获取设置状态文本
    getSetupStatusText(setupId) {
      let totalNodes = this.nodes.length;
      let completedNodes = this.nodes.filter(node => node.status === 2).length;

      // console.log(totalNodes);
      // console.log(completedNodes);

      // // 获取该阶段的所有节点
      // const nodes = this.nodes.filter(node => node.setupid === setupId)
      // if (!nodes || nodes.length === 0) return '0/0'
      
      // // 获取已完成的节点数
      // const completedNodes = nodes.filter(node => node.status === 2)
      // // 总节点数
      // const totalNodes = nodes.length
      
      // 计算完成百分比
      const percentage = Math.round((completedNodes / totalNodes) * 100)
      
      return `${completedNodes}/${totalNodes} (${percentage}%)`
    },
    // 获取节点状态类型
    getNodeStatusType(status) {
      const types = {
        0: 'info',
        1: 'warning',
        2: 'success'
      }
      return types[status] || 'info'
    },
    // 获取节点状态文本
    getNodeStatusText(status) {
      const texts = {
        0: '未开始',
        1: '进行中',
        2: '已完成'
      }
      return texts[status] || '未知'
    },
    // // 获取yyyy-mm-dd格式的时间
    // getyyyymmdd(date) {
    //   if (!date) return '';
    //   // 确保date是字符串类型
    //   const dateStr = String(date);
    //   return dateStr.substring(0, 10);
    // },
    // 获取设置节点
    getSetupNodes(setupId) {
      return this.nodes.filter(node => node.setupid === setupId)
    },
    // 处理节点点击
    async handleNodeClick(node) {
      this.actnodeid = node.id;
      console.log('nodeCLICK');
      await this.fetchNodeInfo(node.id) // 获取节点详情
    },
    // 完成节点
    async completeNode(nodeId,type) {

     if(this.currentNode.nodemanger !== this.userInfo.uid && this.caseInfo.can_edit !== 1){
      this.$message.warning('编辑权限不足')
      return
     }

     let confirmText = '确认完成该节点？'
     if(type == 0){
      confirmText = '确认取消节点完成状态？'
     }


      
      // 实现完成节点的逻辑
      this.$confirm(confirmText, '确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const response = await caseApi.completeNode({
          case_id: this.caseId,
          id: nodeId,
          type: type
        })
        console.log(response);
        if (response.status === 200) {
          this.$message.success('节点完成')
          await this.fetchNodeInfo(nodeId)
          await this.fetchNodes(this.currentNode.setupid)
          
        }
      }).catch(() => {})

     
    },
    // 提交工作记录
    async submitWorkLog() {
      if (!this.newWorkLog.trim()) {
        this.$message.warning('请输入工作记录内容')
        return
      }
      
      try {
        this.submittingLog = true
        let logdata = {
          case_id: this.caseId,
          node_id: this.currentNode.id,
          content: this.newWorkLog.trim(),
          files: this.workLogFiles,
          visible: this.workLogVisible ? 1 : 0
        }

        console.log(logdata);
        const response = await caseApi.addNodeWorkLog({
          case_id: this.caseId,
          node_id: this.currentNode.id,
          content: this.newWorkLog.trim(),
          files: this.workLogFiles,
          visible: this.workLogVisible ? 1 : 0
        })
        
        if (response.status === 200) {
          this.$message.success('工作记录已添加')
          this.workLogFiles = [];
          this.newWorkLog = '' // 清空输入
          this.workLogVisible = false // 重置可见性
          await this.fetchNodeInfo(this.currentNode.id) // 重新获取节点信息
        } else {
          this.$message.error(response.message || '添加失败')
        }
      } catch (error) {
        console.error('添加工作记录失败:', error)
        this.$message.error('添加失败，请重试')
      } finally {
        this.submittingLog = false
      }
    },
    // 添加初始化表单数据的方法
    // initFormModel() {
    //   if (this.currentNode && this.currentNode.form) {
    //     const formData = {};
    //     this.currentNode.form.forEach(field => {
    //       let value = field.value;
          
    //       // 处理图片和附件类型数据
    //       if (field.type === 'image' || field.type === 'upload') {
    //         value = this.parseImageValue(value);
    //       }
          
    //       // 处理开关类型数据
    //       if (field.type === 'switch') {
    //         value = value === '1' || value === true;
    //       }
          
    //       this.$set(formData, field.key, value);
    //     });
    //     this.formModel = formData;
    //   }
    // },
    // 修改获取节点详情的方法
    async fetchNodeInfo(nodeId) {
      this.nodeLoading = true;

      if(nodeId == ''){
        return;
      }

      try {
        const response = await caseApi.getNodeInfo({
          id: nodeId
        });
        
        if (response.status === 200) {
          // 处理表单数据还原
          if (response.data.form && response.data.form.length > 0) {
            response.data.form = response.data.form.map(field => {
              let newField = { ...field };
              
              // 处理开关类型
              if (field.type === 'switch') {
                newField.value = field.value === '1' || field.value === 'true';
              }
              
              // 处理图片类型
              if (field.type === 'image' && typeof field.value === 'string') {
                try {
                  newField.value = JSON.parse(field.value);
                } catch (error) {
                  console.error('解析图片数据失败:', error);
                  newField.value = [];
                }
              }
              if(response.data.status == 2){
                if (field.type === 'upload' && typeof field.value === 'string') {
                  newField.value = JSON.parse(field.value);
                }
              }

              
              return newField;
            });
          }
          
          // 更新当前节点数据
          this.currentNode = response.data;
          // 初始化表单数据
          this.initFormModel();
          
        } else {
          this.$message.error(response.message || '获取节点信息失败');
        }
      } catch (error) {
        console.error('获取节点信息失败:', error);
        this.$message.error('获取节点信息失败，请重试');
      } finally {
        this.nodeLoading = false;
      }
    },
    
    // 处理步骤点击
    async handleSetupChange(setupId) {
      this.activeSetup = setupId
      await this.fetchNodes(setupId) // 获取该步骤的节点列表
    },
    
    // 处理切换可见状态
    async handleToggleVisible(log) {
      try {
        let tips = log.visible ? '确认取消客户可见？' : '确认设置客户可见？';
        await this.$confirm(tips, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        let visible = log.visible ? 0 : 1;
        
        const response = await caseApi.updateWorkLogVisible({
          id: log.id,
          visible: visible  // 设置不可见状态
        })
        console.log(response);
        if (response.status === 200) {
          this.$message.success('操作成功')
          // 重新获取工作记录列表
          await this.fetchNodeInfo(this.currentNode.id)
        } else {
          this.$message.error(response.message || '操作失败')
        }
      } catch (error) {
        if (error !== 'cancel') {
          console.error('更新可见状态失败:', error)
          this.$message.error('操作失败，请重试')
        }
      }
    },
    
    // 处理删除工作记录
    async handleDeleteLog(log) {
      try {
        await this.$confirm('确认删除该工作记录？', '警告', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        
        const response = await caseApi.deleteWorkLog({
          case_id: this.caseId,
          id: log.id
        })
        
        if (response.status === 200) {
          this.$message.success('工作记录已删除')
          // 重新获取工作记录列表
          await this.fetchNodeInfo(this.currentNode.id)
        } else {
          this.$message.error(response.message || '删除失败')
        }
      } catch (error) {
        if (error !== 'cancel') {
          console.error('删除工作记录失败:', error)
          this.$message.error('删除失败，请重试')
        }
      }
    },
    
    // 修改解析图片值的方法
    parseImageValue(value) {
      if (!value) return [];
      if (Array.isArray(value)) return value;
      
      try {
        // 先尝试解析一次
        let parsed = JSON.parse(value);
        // 如果解析结果还是字符串，再解析一次
        if (typeof parsed === 'string') {
          parsed = JSON.parse(parsed);
        }
        return Array.isArray(parsed) ? parsed : [];
      } catch (error) {
        console.error('解析数据失败:', error);
        return [];
      }
    },
    
    // 添加获取预览列表的方法
    getPreviewList(value) {
      const images = this.parseImageValue(value)
      return images.map(img => img.url)
    },
    
    // 处理编辑时间按钮点击
    handleEditTime() {
      this.timeForm.datetime = this.currentNode.automsgtime
      this.timeDialogVisible = true
    },
    
    // 提交编辑时间
    async submitEditTime() {
      if (!this.timeForm.datetime) {
        this.$message.warning('请选择时间')
        return
      }

      try {
        this.submittingTime = true
        const response = await caseApi.updateNodeAutoTime({
          case_id: this.caseId,
          id: this.currentNode.id,
          time: this.timeForm.datetime
        })
        
        if (response.status === 200) {
          this.$message.success('时间修改成功')
          this.timeDialogVisible = false
          // 更新节点信息
          await this.fetchNodeInfo(this.currentNode.id)
        } else {
          this.$message.error(response.message || '修改失败')
        }
      } catch (error) {
        console.error('修改时间失败:', error)
        this.$message.error('修改失败，请重试')
      } finally {
        this.submittingTime = false
      }
    },
    // 获取工作记录列表
    async fetchWorkLogs() {
      try {
        this.workLogLoading = true
        const response = await caseApi.getCaseWorkLogs({
          case_id: this.caseId
        })
        
        if (response.status === 200) {
          this.workLogs = response.data
        } else {
          this.$message.error(response.message || '获取工作记录失败')
        }
      } catch (error) {
        console.error('获取工作记录失败:', error)
        this.$message.error('获取工作记录失败，请重试')
      } finally {
        this.workLogLoading = false
      }
    },
    // 获取消息记录列表
    async fetchMessages() {
      try {
        const response = await caseApi.getCaseMessages({
          caseid: this.caseId
        })
        
        if (response.status === 200) {
          this.messages = response.data
        } else {
          this.$message.error(response.message || '获取消息记录失败')
        }
      } catch (error) {
        console.error('获取消息记录失败:', error)
        this.$message.error('获取消息记录失败，请重试')
      }
    },
    // 修改提交表单的方法
    async submitNodeForm() {
      try {
        // 使用表单验证
        await this.$refs.nodeForm.validate();
        
        this.submittingForm = true;
        
        // 将表单数据转换回数组格式
        const formData = this.currentNode.form.map(field => {
          let value = this.formModel[field.key];
          
          // 处理图片和附件类型数据
          if ((field.type === 'image' || field.type === 'upload') && Array.isArray(value)) {
            value = JSON.stringify(value);
          }
          
          // 处理开关类型数据
          if (field.type === 'switch') {
            value = value ? '1' : '0';
          }
          
          return {
            ...field,
            value: value
          };
        });

        const response = await caseApi.updateNodeForm({
          case_id: this.caseId,
          node_id: this.currentNode.id,
          node_name: this.currentNode.name,
          form_data: formData
        });
        
        if (response.status === 200) {
          this.$message.success('表单提交成功');
          await this.fetchNodeInfo(this.currentNode.id);
        } else {
          this.$message.error(response.message || '提交失败');
        }
      } catch (error) {
        if (error === 'validate') {
          return;
        }
        console.error('提交节点表单失败:', error);
        this.$message.error('提交失败，请重试');
      } finally {
        this.submittingForm = false;
      }
    },
    // 发送节点消息
    async sendNodeMessage(type) {
      try {
        const content = type === 'lawyer' 
          ? this.currentNode.lawyermsgmodel 
          : this.currentNode.clientmsgmodel
          
          console.log(this.currentNode.id);
          console.log(type);

          // return;


        const response = await caseApi.sendNodeMessage({
          nodeid: this.currentNode.id,
          type: type,
        })
        
        if (response.status === 200) {
          this.$message.success('消息发送成功')
          // 重新获取节点信息
          await this.fetchNodeInfo(this.currentNode.id)
        } else {
          this.$message.error(response.message || '发送失败')
        }
      } catch (error) {
        console.error('发送消息失败:', error)
        this.$message.error('发送失败，请重试')
      }
    },
    // 获取代理类型文本
    getProxyTypeText(type) {
      const types = {
        '1': '起诉',
        '2': '辩护',
        '3': '调解',
        '4': '应诉'
      }
      return types[type] || '未知'
    },
    
    // 获取代理类型样式类名
    getProxyTypeClass(type) {
      return {
        '1': 'proxy-type1',
        '2': 'proxy-type2',
        '3': 'proxy-type3',
        '4': 'proxy-type4'
      }[type] || ''
    },
    
    // 查看冲突案件
    viewConflictCase(item) {
      // 如果是当前案件，不进行跳转
      if (item.id === this.caseId) {
        return
      }
      
      // 先替换当前路由，再重新获取案件
      this.$router.replace({
        path: '/cases/info',
        query: { id: item.id }
      }).then(() => {
        this.caseId = item.id
        this.fetchCaseInfo()
      }).catch(err => {
        // 忽略重复导航的错误
        if (err.name !== 'NavigationDuplicated') {
          console.error('路由跳转失败:', err)
        }
      })
    },
    // 图片上传前检查
    beforeImageUpload(file, field) {
      // 检查文件类型
      const allowedTypes = field.filetype.split(',').map(type => type.trim().toLowerCase());
      const fileExt = file.name.split('.').pop().toLowerCase();
      
      if (!allowedTypes.includes(fileExt)) {
        this.$message.error(`只能上传 ${field.filetype} 格式的图片!`);
        return false;
      }
      
      // 检查文件大小
      const maxSize = field.maxsize || 2;  // 默认2MB
      const isLtMax = file.size / 1024 / 1024 < maxSize;
      
      if (!isLtMax) {
        this.$message.error(`图片大小不能超过 ${maxSize}MB!`);
        return false;
      }
      
      return true;
    },
    
    // 获取接受的文件类型
    getAcceptTypes(fileTypes) {
      if (!fileTypes) return '';
      return fileTypes.split(',')
        .map(type => `.${type.trim()}`)
        .join(',');
    },
    
    // 修改文件上传前检查
    beforeFileUpload(file, field) {
      // 检查文件类型
      const allowedTypes = field.filetype.split(',').map(type => type.trim().toLowerCase());
      const fileExt = file.name.split('.').pop().toLowerCase();
      const isValidType = allowedTypes.some(type => {
        switch(type) {
          case 'doc':
            return fileExt === 'doc' || fileExt === 'docx';
          case 'xls':
            return fileExt === 'xls' || fileExt === 'xlsx';
          case 'ppt':
            return fileExt === 'ppt' || fileExt === 'pptx';
          default:
            return fileExt === type;
        }
      });
      
      if (!isValidType) {
        this.$message.error(`只能上传 ${field.filetype} 格式的文件!`);
        return false;
      }
      
      // 检查文件大小
      const maxSize = field.maxsize || 10;  // 默认10MB
      const isLtMax = file.size / 1024 / 1024 < maxSize;
      
      if (!isLtMax) {
        this.$message.error(`文件大小不能超过 ${maxSize}MB!`);
        return false;
      }
      
      return true;
    },

 // 处理工作记录文件上传
 async handleWorkLogFileUpload(params) {
       console.log(params);
      //  return;
      try {
        const formData = new FormData();
        formData.append('file', params.file);
        formData.append('case_id', this.caseId);
        formData.append('node_id', this.currentNode.id);
        formData.append('field_key', 'attachments');
        console.log(params.file);
        const response = await caseApi.uploadNodeFile(formData);
        if (response.status === 200) {
          // 确保 formModel[field.key] 是数组
          // if (!Array.isArray(this.formModel[field.key])) {
          //   this.$set(this.formModel, field.key, []);
          // }
          
          // 添加服务器返回的文件信息
          const fileInfo = {
            name: params.file.name,
            url: response.data.url,
            size: params.file.size,
          };
        
          // 更新文件列表
          this.workLogFiles.push(fileInfo);

          console.log(this.workLogFiles);
          // return;
          
          params.onSuccess(fileInfo);
          this.$message.success('上传成功');
        } else {
          params.onError(new Error(response.message || '上传失败'));
          this.$message.error(response.message || '上传失败');
        }
      } catch (error) {
        params.onError(error);
        console.error('上传文件失败:', error);
        this.$message.error('上传失败，请重试');
      }
    },

    
    // 处理文件上传
    async handleFileUpload(params, field) {
      try {
        const formData = new FormData();
        formData.append('file', params.file);
        formData.append('case_id', this.caseId);
        formData.append('node_id', this.currentNode.id);
        formData.append('field_key', field.key);
        
        const response = await caseApi.uploadNodeFile(formData);
        
        if (response.status === 200) {
          // 确保 formModel[field.key] 是数组
          if (!Array.isArray(this.formModel[field.key])) {
            this.$set(this.formModel, field.key, []);
          }
          
          // 添加服务器返回的文件信息
          const fileInfo = {
            name: params.file.name,
            url: response.data.url,
            size: params.file.size,
            uid: Date.now(),
            status: 'success'
          };
          
          // 更新文件列表
          const newList = [...(this.formModel[field.key] || []), fileInfo];
          this.$set(this.formModel, field.key, newList);
          
          params.onSuccess(fileInfo);
          this.$message.success('上传成功');
        } else {
          params.onError(new Error(response.message || '上传失败'));
          this.$message.error(response.message || '上传失败');
        }
      } catch (error) {
        params.onError(error);
        console.error('上传文件失败:', error);
        this.$message.error('上传失败，请重试');
      }
    },
    
    // 处理图片上传
    async handleImageUpload(params, field) {
      try {
        const formData = new FormData();
        formData.append('file', params.file);
        formData.append('case_id', this.caseId);
        formData.append('node_id', this.currentNode.id);
        formData.append('field_key', field.key);
        
        const response = await caseApi.uploadImage(formData);
        
        if (response.status === 200) {
          // 确保 formModel[field.key] 是数组
          if (!Array.isArray(this.formModel[field.key])) {
            this.$set(this.formModel, field.key, []);
          }
          
          // 添加服务器返回的图片信息
          const imageInfo = {
            name: params.file.name,
            url: response.data.url
          };
          
          // 更新图片列表
          const newList = [...(this.formModel[field.key] || []), imageInfo];
          this.$set(this.formModel, field.key, newList);
          
          params.onSuccess(imageInfo);
          this.$message.success('上传成功');
        } else {
          params.onError(new Error(response.message || '上传失败'));
          this.$message.error(response.message || '上传失败');
        }
      } catch (error) {
        params.onError(error);
        console.error('上传图片失败:', error);
        this.$message.error('上传失败，请重试');
      }
    },

    
    // 工作记录处理文件移除
    handleWorkLogRemoveFile(file) {
      if (!this.workLogFiles) {
        this.workLogFiles = [];
        return;
      }
      
      const fileList = [...this.workLogFiles];
      const index = fileList.findIndex(item => item.url === file.url);
      if (index > -1) {
        fileList.splice(index, 1);
        this.workLogFiles = fileList;
      }
      console.log(this.workLogFiles);
    },
    
    // 处理文件移除
    handleRemoveFile(field, file) {
      if (!this.formModel[field.key]) {
        this.$set(this.formModel, field.key, []);
        return;
      }
      
      const fileList = [...this.formModel[field.key]];
      const index = fileList.findIndex(item => item.url === file.url);
      if (index > -1) {
        fileList.splice(index, 1);
        this.$set(this.formModel, field.key, fileList);
      }
    },
    
    // 下载文件
    downloadFile(file) {
      window.open(file.url)
    },
    
    // 处理清除用户表单
    async handleClearClientForm() {
      try {
        await this.$confirm('确认清除用户表单数据？此操作不可恢复', '警告', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        console.log(this.caseId, this.currentNode.id)
        const response = await caseApi.clearNodeClientForm({
          case_id: this.caseId,
          node_id: this.currentNode.id
        })
        
        if (response.status === 200) {
          this.$message.success('表单已清除')
          // 重新获取节点信息
          await this.fetchNodeInfo(this.currentNode.id)
        } else {
          this.$message.error(response.message || '除失败')
        }
      } catch (error) {
        if (error !== 'cancel') {
          console.error('清除表单失败:', error)
          this.$message.error('清除失败，请重试')
        }
      }
    },
    
    // 获取步骤列表和第一个步骤的节点
    async fetchSetupAndNodes() {
      this.firstLoad = true;
      try {
        // 获取案件阶段
        const setupResponse = await caseApi.getCaseSetup({
          typeid: this.caseInfo.type,
          caseid: this.caseId
        })
        
        if (setupResponse.status === 200) {
          this.setup = setupResponse.data.setups;
          
          // 如果有阶段数据，获取第一个阶段的节点
          if (this.setup.length > 0) {
            this.activeSetup = setupResponse.data.active.setupid
            this.actnodeid = setupResponse.data.active.nodeid
            await this.fetchNodes(setupResponse.data.active.setupid)
            // if(this.firstLoad){
            //   await this.fetchNodes(setupResponse.data.active.setupid)
            //   this.firstLoad = false
            // }else{
            //   await this.fetchNodeInfo(this.setup[0].id)
            // }

            const firstSetup = this.setup[0]
            this.activeSetup = setupResponse.data.active.setupid
            this.actnodeid = setupResponse.data.active.nodeid
            console.log(firstSetup);
            // await this.fetchNodes(setupResponse.data.active.setupid)
            // console.log(setupResponse.data.active);
            // this.activeSetup = setupResponse.data.active.setupid;
            // await this.fetchNodes(this.activeSetup)
          }
        } else {
          this.$message.error(setupResponse.message || '获取流程阶段失败')
        }
      } catch (error) {
        console.error('获取流程阶段失败:', error)
        this.$message.error('获取流程阶段失败，请重试')
      }
    },
    
    // 获取阶段节点列表
    async fetchNodes(setupId) {
      try {
        const nodesResponse = await caseApi.getCaseNodes({
          caseid: this.caseInfo.id,
          setupid: setupId
        })
        
        if (nodesResponse.status === 200) {
          // 先设置节点列表
          this.nodes = nodesResponse.data
      
          
          // 如果有节点数据，获取第一个节点的详情
          if (this.nodes.length > 0) {
            // 先清空当前节点，避免显示旧数据
            this.currentNode = null
            // 等待获取节点详情完成
            console.log('ac',this.firstLoad);
            // await this.fetchNodeInfo(this.actnodeid)
            if(this.firstLoad){
              await this.fetchNodeInfo(this.actnodeid)
             
            }else{
              await this.fetchNodeInfo(this.nodes[0].id)
            }
            this.firstLoad = false
          } else {
            this.currentNode = null
          }
        } else {
          this.$message.error(nodesResponse.message || '获取节点失败')
        }
      } catch (error) {
        console.error('获取节点失败:', error)
        this.$message.error('获取节点失败，请重试')
      }
    },
    // 获取上传文件列表
    getUploadFileList(value) {
      try {
        if (!value) return [];
        if (Array.isArray(value)) return value;
        
        // 尝试解析字符串
        const files = JSON.parse(value);
        return Array.isArray(files) ? files : [];
      } catch (error) {
        console.error('解析文件列表失败:', error);
        return [];
      }
    },
    // 修改解析值的方法
    parseFileValue(value) {
      if (!value) return [];
      if (Array.isArray(value)) return value;
      
      try {
        // 先去掉外层的引号
        if (value.startsWith('"') && value.endsWith('"')) {
          value = value.slice(1, -1);
        }
        // 解析转义后的 JSON 字符串
        const parsed = JSON.parse(value);
        return Array.isArray(parsed) ? parsed : [];
      } catch (error) {
        console.error('解析文件数据失败:', error, value);
        return [];
      }
    },

    // 整合后的初始化表单数据方法
    // initFormModel() {
    //   if (this.currentNode && this.currentNode.form) {
    //     const formData = {};
    //     this.currentNode.form.forEach(field => {
    //       let value = field.value;
          
    //       // 处理图片和附件类型数据
    //       if (field.type === 'image' || field.type === 'upload') {
    //         value = this.parseFileValue(value);
    //       }
    //       // 处理开关类型数据
    //       else if (field.type === 'switch') {
    //         value = value === '1' || value === true;
    //       }
          
    //       this.$set(formData, field.key, value);
    //     });
    //     this.formModel = formData;

    //     // 打印调试信息
    //     console.log('初始化表单数据:', formData);
    //   }
    // },

    // 修改文件上传方法
    async handleFileUpload(params, field) {
      try {
        const formData = new FormData();
        formData.append('file', params.file);
        formData.append('case_id', this.caseId);
        formData.append('node_id', this.currentNode.id);
        formData.append('field_key', field.key);
        
        const response = await caseApi.uploadNodeFile(formData);
        
        if (response.status === 200) {
          // 构建文件信息对象
          const fileInfo = {
            name: params.file.name,
            url: response.data.url,
            size: params.file.size,
            uid: Date.now(),
            status: 'success'
          };
          
          // 获取当前文件列表
          let files = this.parseFileValue(field.value);
          files.push(fileInfo);
          
          // 更新字段值和表单模型
          field.value = JSON.stringify(files);
          this.$set(this.formModel, field.key, files);
          
          params.onSuccess(fileInfo);
          this.$message.success('上传成功');
        } else {
          params.onError(new Error(response.message || '上传失败'));
          this.$message.error(response.message || '上传失败');
        }
      } catch (error) {
        params.onError(error);
        console.error('上传文件失败:', error);
        this.$message.error('上传失败，请重试');
      }
    },

    // 修改文件移除方法
    handleRemoveFile(field, file) {
      try {
        let files = this.parseFileValue(field.value);
        const index = files.findIndex(item => item.url === file.url);
        
        if (index > -1) {
          files.splice(index, 1);
          field.value = JSON.stringify(files);
          this.$set(this.formModel, field.key, files);
        }
      } catch (error) {
        console.error('移除文件失败:', error);
        this.$message.error('移除文件失败');
      }
    },

    // 修改提交表单的方法
    async submitNodeForm() {
      try {
        await this.$refs.nodeForm.validate();
        this.submittingForm = true;
        
        // 转换表单数据
        const formData = this.currentNode.form.map(field => {
          let value = field.value;
          
          // 处理图片类型数据
          if (field.type === 'image' && Array.isArray(this.formModel[field.key])) {
            value = JSON.stringify(this.formModel[field.key]);
          }
          // 处理附件类型数据
          else if (field.type === 'upload' && Array.isArray(this.formModel[field.key])) {
            value = JSON.stringify(this.formModel[field.key]);
          }
          // 处理开关类型数据
          else if (field.type === 'switch') {
            value = this.formModel[field.key] ? '1' : '0';
          }
          else {
            value = this.formModel[field.key];
          }
          
          return {
            ...field,
            value
          };
        });

        const response = await caseApi.updateNodeForm({
          case_id: this.caseId,
          node_id: this.currentNode.id,
          node_name: this.currentNode.name,
          form_data: formData
        });
        
        if (response.status === 200) {
          this.$message.success('表单提交成功');
          await this.fetchNodeInfo(this.currentNode.id);
        } else {
          this.$message.error(response.message || '提交失败');
        }
      } catch (error) {
        if (error === 'validate') return;
        console.error('提交节点表单失败:', error);
        this.$message.error('提交失败，请重试');
      } finally {
        this.submittingForm = false;
      }
    },

    // 专门处理服务器返回的附件数据
    parseServerUploadValue(value) {
      if (!value) return [];
      if (Array.isArray(value)) return value;
      
      try {
        // 处理服务器返回的双重转义字符串
        let parsedValue = value;
        // 可能需要多次解析
        while (typeof parsedValue === 'string') {
          parsedValue = JSON.parse(parsedValue);
        }
        return Array.isArray(parsedValue) ? parsedValue : [];
      } catch (error) {
        console.error('解析服务器附件数据失败:', error, value);
        return [];
      }
    },

    // 修改初始化表单数据方法
    initFormModel() {
      console.log(this.currentNode);
      if (this.currentNode && this.currentNode.form) {
        const formData = {};
        this.currentNode.form.forEach(field => {
          let value = field.value;
          
          // 处理图片类型数据
          if (field.type === 'image') {
            value = this.parseFileValue(value);
          } 
          // 处理附件类型数据
          if(this.currentNode.status !== 2){
            if (field.type === 'upload') {
              value = this.parseServerUploadValue(value);
                console.log('33');
            }
          }


         
          // 处理开关类型数据
          if (field.type === 'switch') {
            value = value === '1' || value === true;
          }
          
          this.$set(formData, field.key, value);
        });
        this.formModel = formData;
        // console.log('初始化表单数据:', formData);
      }
    },

    // 修改文件上传方法（保持原有的上传格式）
    async handleFileUpload(params, field) {
      try {
        const formData = new FormData();
        formData.append('file', params.file);
        formData.append('case_id', this.caseId);
        formData.append('node_id', this.currentNode.id);
        formData.append('field_key', field.key);
        
        const response = await caseApi.uploadNodeFile(formData);
        
        if (response.status === 200) {
          // 构建文件信息对象
          const fileInfo = {
            name: params.file.name,
            url: response.data.url,
            size: params.file.size,
            uid: Date.now(),
            status: 'success'
          };
          
          // 获取当前文件列表
          let files = Array.isArray(this.formModel[field.key]) ? this.formModel[field.key] : [];
          files = [...files, fileInfo];
          
          // 更新表单模型
          this.$set(this.formModel, field.key, files);
          
          // 更新字段值（保持原有的格式）
          field.value = JSON.stringify(files);
          
          params.onSuccess(fileInfo);
          this.$message.success('上传成功');
        } else {
          params.onError(new Error(response.message || '上传失败'));
          this.$message.error(response.message || '上传失败');
        }
      } catch (error) {
        params.onError(error);
        console.error('上传文件失败:', error);
        this.$message.error('上传失败，请重试');
      }
    },

    // 修改文件移除方法
    handleRemoveFile(field, file) {
      try {
        let files = Array.isArray(this.formModel[field.key]) ? this.formModel[field.key] : [];
        const index = files.findIndex(item => item.url === file.url);
        
        if (index > -1) {
          files.splice(index, 1);
          // 更新表单模型
          this.$set(this.formModel, field.key, files);
          // 更新字段值（保持原有的格式）
          field.value = JSON.stringify(files);
        }
      } catch (error) {
        console.error('移除文件失败:', error);
        this.$message.error('移除文件失败');
      }
    },
    
    // 根据类型获取人员列表
    getPersonsByType(type) {

      return this.caseInfo.otherclient.filter(person => person.type === type);
    },
    
    // 查看人员详情
    viewPerson(person, isDefendant = false) {
      // 实现查看详情逻辑
    },
    
    // 添加人员
    handleAddPerson() {
      this.personForm = {
        type: 1,
        name: '',
        phone: '',
        idcard: '',
        address: '',
        caselink: '',
        remark: '',
        caseid: this.caseId
      }
      this.personDialogVisible = true
    },
    
    // 编辑人员
    handleEditPerson(person) {
      this.personForm = { ...person }
      this.personDialogVisible = true
    },
    
    // 删除人员
    async handleDeletePerson(person) {
      try {
        await this.$confirm('确认删除该人员信息？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        });
        
        // 调用删除接口
        const response = await caseApi.deletePerson({
          id: person.id
        });
        
        if (response.status === 200) {
          this.$message.success('删除成功');
          // 重新获取人员列表
          await this.fetchCaseInfo();
        } else {
          this.$message.error(response.message || '删除失败');
        }
      } catch (error) {
        if (error !== 'cancel') {
          console.error('删除人员失败:', error);
          this.$message.error('删除失败，请重试');
        }
      }
    },
    
    // 获取人员列表
    // async fetchPersons() {
    //   try {
    //     const response = await caseApi.getCasePersons({
    //       case_id: this.caseId
    //     });
        
    //     if (response.status === 200) {
    //       this.persons = response.data;
    //     } else {
    //       this.$message.error(response.message || '获取人员列表失败');
    //     }
    //   } catch (error) {
    //     console.error('获取人员列表失败:', error);
    //     this.$message.error('获取人员列表失败，请重试');
    //   }
    // }
    resetPersonForm() {
      if (this.$refs.personForm) {
        this.$refs.personForm.resetFields()
      }
      this.personForm = {
        type: 1,
        name: '',
        phone: '',
        idcard: '',
        address: '',
        caselink: '',
        remark: '',
        caseid: this.caseId
      }
    },
    async submitPersonForm() {
      try {
        await this.$refs.personForm.validate()
        
        this.submittingPerson = true
        const isEdit = Boolean(this.personForm.id)
        
        console.log(this.personForm);
        
        // 调用添加或编辑接口
        const response = await caseApi.addPerson({
          ...this.personForm,
          caseid: this.caseId
        })

        // const response = await caseApi[isEdit ? 'updatePerson' : 'addPerson']({
        //   ...this.personForm,
        //   caseid: this.caseId
        // })
        
        if (response.status === 200) {
          console.log(response);
          this.$message.success(isEdit ? '编辑成功' : '添加成功')
          this.personDialogVisible = false
          // 重新获取案件信息
          await this.fetchCaseInfo()
        } else {
          this.$message.error(response.message || (isEdit ? '编辑失败' : '添加失败'))
        }
      } catch (error) {
        if (error === 'validate') return
        // console.error(isEdit ? '编辑人员失败:' : '添加人员失败:', error)
        // this.$message.error(isEdit ? '编辑失败，请重试' : '添加失败，请重试')
      } finally {
        this.submittingPerson = false
      }
    },
    // 快速输入案件关系
    quickInputRelation(relation) {
      this.personForm.caselink = relation;
    },
    // 快速输入备注关系
    quickInputRemark(relation) {
      // 如果已有内容，则在末尾添加逗号分隔
      if (this.personForm.remark) {
        this.personForm.remark = this.personForm.remark.trim() + '，' + relation;
      } else {
        this.personForm.remark = relation;
      }
    }
  },
  watch: {
    // 监听阶段切换
    activeSetup: {
      handler(newVal) {
        if (newVal) {
          this.handleSetupChange(newVal)
        }
      },
      immediate: true
    },
    activeTab: {
      handler(newVal) {
        if (newVal === 'worklog') {
          this.fetchWorkLogs()
        } else if (newVal === 'message') {
          this.fetchMessages()
        }
      },
      immediate: true
    }
  }
}


</script>

<style lang="less" scoped>
.info-container {
  min-height: 100vh;
  background: #f0f2f5;
}

.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  
  .right {
    display: flex;
    gap: 12px;
  }
}

.info-section {
  background: #fff;
  border-radius: 4px;
  padding: 24px;
  margin-bottom: 24px;
  
  &:last-child {
    margin-bottom: 0;
  }
  
  .section-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;
    
    h3 {
      margin: 0;
      font-size: 16px;
      color: #262626;
    }
    
    .status-tags {
      display: flex;
      align-items: center;
      gap: 12px;
      
      .proxy-type {
        font-size: 13px;
        padding: 0 8px;
        height: 24px;
        line-height: 22px;
        border-radius: 2px;
        border: 1px solid;
        
        &.proxy-type1 {
          color: #ffffff;
          border-color: #105a9f;
          background: #105a9f;
        }
        
        &.proxy-type2 {
          color: #ffffff;
          border-color: #ff4d4f;
          background: #ff4d4f;
        }
        
        &.proxy-type3 {
          color: #ffffff;
          border-color: #c68c18;
          background: #c68c18;
        }
        &.proxy-type4 {
          color: #ffffff;
          border-color: #a99669;
          background: #a99669;
        }
      }
    }
  }
  
  :deep(.el-descriptions) {
    .el-descriptions__body {
      background-color: transparent !important;
      
      table {
        width: 100%;
        background-color: transparent !important;
        
        tbody {
          tr {
            background-color: transparent !important;
            
            td {
              &.el-descriptions-item__label {
                background-color: rgba(250, 250, 250, 0.8) !important;
                width: 120px !important;  // 添加固定宽度
                min-width: 120px !important;  // 确保最小宽度
                max-width: 120px !important;  // 确保最大宽度
                white-space: nowrap !important;  // 防止文字换行
                padding: 12px 16px !important;  // 调整内边距
              }
              
              &.el-descriptions-item__content {
                background-color: rgba(255, 255, 255, 0.8) !important;
                padding: 12px 16px !important;  // 调整内边距
              }
            }
          }
        }
      }
    }
    
    .party-info {
      .party-details {
        display: flex;
        flex-wrap: wrap;
        gap: 16px;
        
        .detail-item {
          flex: 1;
          min-width: 200px;
          display: flex;
          
          &.full-width {
            flex: 0 0 100%;
          }
          
          .label {
            color: #8c8c8c;
            margin-right: 8px;
            white-space: nowrap;
          }
          
          .value {
            color: #262626;
            word-break: break-all;
          }
        }
      }
    }
    
    .description-content {
      color: #262626;
      line-height: 1.6;
      white-space: pre-wrap;
      word-break: break-all;
      
      &:empty::after {
        content: '暂无内容';
        color: #bfbfbf;
      }
    }
  }
}

.timeline-content {
  h4 {
    margin: 0 0 8px;
    font-size: 14px;
    color: #262626;
  }
  
  p {
    margin: 0 0 12px;
    color: #595959;
    font-size: 13px;
  }
  
  .timeline-files {
    background: #fafafa;
    padding: 8px 12px;
    border-radius: 4px;
    
    .file-item {
      display: flex;
      align-items: center;
      padding: 4px 0;
      
      i {
        color: #8c8c8c;
        margin-right: 8px;
      }
      
      .file-name {
        flex: 1;
        color: #595959;
        font-size: 13px;
      }
    }
  }
}

:deep(.el-table) {
  .delete-btn {
    color: #ff4d4f;
    
    &:hover {
      color: #ff7875;
    }
  }
}

// 编辑表单样式
.form-section {
  margin-bottom: 24px;
  padding-bottom: 24px;
  border-bottom: 1px solid #f0f0f0;
  
  &:last-child {
    margin-bottom: 0;
    padding-bottom: 0;
    border-bottom: none;
  }
  
  .section-title {
    font-size: 15px;
    font-weight: 500;
    color: #262626;
    margin-bottom: 16px;
    padding-left: 8px;
    border-left: 3px solid #1890ff;
  }
}

:deep(.el-dialog__body) {
  padding: 20px 24px;
}

:deep(.el-form-item) {
  margin-bottom: 18px;
  
  &:last-child {
    margin-bottom: 0;
  }
}

:deep(.el-select) {
  width: 100%;
}

.dialog-footer {
  text-align: right;
  padding-top: 20px;
}

// 添加禁用按钮样式
:deep(.el-button.is-disabled) {
  cursor: not-allowed;
  
  &:hover {
    background-color: #F5F7FA;
    border-color: #DCDFE6;
    color: #C0C4CC;
  }
}

// 添加提示样式
:deep(.el-tooltip__popper) {
  font-size: 12px;
  padding: 6px 12px;
}

// 添加删除按钮样式
:deep(.danger-item) {
  color: #f56c6c;
  
  &:not(.is-disabled):hover {
    background-color: #fef0f0;
    color: #f56c6c;
  }
  
  &.is-disabled {
    color: #c0c4cc;
    cursor: not-allowed;
  }
}

// 优化 tooltip 样式
:deep(.el-tooltip__popper) {
  font-size: 12px;
  padding: 6px 12px;
  
  &.is-dark {
    background: rgba(0, 0, 0, 0.75);
  }
}

.tab-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  
  h5 {
    margin: 0;
    font-size: 14px;
    color: #262626;
  }
}

.worklog-list {
  .worklog-item {
    padding: 12px 16px;
    background: #fafafa;
    border-radius: 4px;
    margin-bottom: 12px;
    
    &:last-child {
      margin-bottom: 0;
    }
    
    .log-meta {
      margin-bottom: 8px;
      
      .log-user {
        font-weight: 500;
        color: #262626;
        margin-right: 12px;
      }
      
      .log-time {
        font-size: 12px;
        color: #8c8c8c;
      }
    }
    
    .log-content {
      color: #595959;
      line-height: 1.5;
    }
  }
}

.message-list {
  .message-item {
    padding: 12px 16px;
    background: #fafafa;
    border-radius: 4px;
    margin-bottom: 12px;
    
    &:last-child {
      margin-bottom: 0;
    }
    
    .msg-meta {
      display: flex;
      align-items: center;
      margin-bottom: 8px;
      gap: 12px;
      
      .msg-type {
        font-weight: 500;
        padding: 2px 8px;
        background: rgba(24,144,255,0.1);
        color: #1890ff;
        border-radius: 2px;
        font-size: 12px;
      }
      
      .msg-time {
        color: #8c8c8c;
        font-size: 12px;
      }
    }
    
    .msg-content {
      color: #262626;
      line-height: 1.6;
      margin-bottom: 8px;
      padding: 8px 12px;
      background: #fff;
      border-radius: 4px;
    }
    
    .msg-receiver {
      font-size: 12px;
      color: #8c8c8c;
    }
  }
}

:deep(.el-tabs__nav-wrap) {
  padding: 0 24px;
  
  &::after {
    height: 1px;
  }
}

:deep(.el-tabs__item) {
  font-size: 14px;
  height: 40px;
  line-height: 40px;
  
  &.is-active {
    font-weight: 500;
  }
}

:deep(.el-dropdown-menu__item) {
  &.is-disabled {
    cursor: not-allowed;
    
    &:hover {
      background-color: transparent;
    }
  }
}

// 添加人员权限相关样式
.user-groups {
  display: flex;
  gap: 40px;
  padding: 20px;
  background: #fafafa;
  border-radius: 8px;
  
  .user-group {
    flex: 1;
    min-width: 0;
    
    .group-title {
      font-size: 14px;
      color: #8c8c8c;
      margin-bottom: 20px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-bottom: 12px;
      border-bottom: 1px solid #f0f0f0;
      
      .el-button {
        padding: 0;
        font-size: 13px;
        
        i {
          margin-right: 4px;
        }
        
        &:hover {
          color: #40a9ff;
        }
      }
    }
    
    .user-list {
      display: flex;
      flex-wrap: wrap;
      gap: 16px;
    }
    
    .user-item {
      display: flex;
      align-items: center;
      gap: 12px;
      padding: 12px 16px;
      background: #fff;
      border-radius: 8px;
      position: relative;
      transition: all 0.3s;
      border: 1px solid #f0f0f0;
      min-width: 180px;
      
      &:hover {
        box-shadow: 0 2px 8px rgba(0,0,0,0.08);
        border-color: #e6f7ff;
        
        .remove-btn {
          opacity: 1;
        }
      }
      
      .user-name {
        font-size: 14px;
        color: #262626;
        font-weight: 500;
      }
      
      .remove-btn {
        padding: 4px;
        position: absolute;
        right: 8px;
        top: 50%;
        transform: translateY(-50%);
        opacity: 0;
        transition: all 0.3s;
        border-radius: 4px;
        
        &:hover {
          color: #ff4d4f;
          background: rgba(255, 77, 79, 0.1);
        }
      }
    }
  }
}

// 优化头像样式
:deep(.el-avatar) {
  background: #e6f7ff;
  color: #1890ff;
  border: 2px solid #fff;
  box-shadow: 0 2px 8px rgba(24,144,255,0.15);
  
  &.el-avatar--icon {
    .el-icon-user {
      font-size: 20px;
    }
  }
  
  img {
    object-fit: cover;
  }
}

// 添加分隔线样式
.user-group + .user-group {
  position: relative;
  
  &::before {
    content: '';
    position: absolute;
    left: -20px;
    top: 0;
    bottom: 0;
    width: 1px;
    background: #f0f0f0;
  }
}

// 添加下拉菜单相关样式
.viewer-dropdown {
  width: 240px !important;
  padding: 0 !important;
  
  .dropdown-header {
    padding: 8px;
    border-bottom: 1px solid #f0f0f0;
    
    .el-input {
      width: 100%;
    }
  }
  
  .lawyer-item {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 4px 0;
    
    .lawyer-name {
      flex: 1;
      font-size: 14px;
      color: #262626;
    }
    
    .lawyer-disabled {
      font-size: 12px;
      color: #8c8c8c;
      background: #f5f5f5;
      padding: 2px 6px;
      border-radius: 2px;
    }
  }
  
  .empty-tip {
    padding: 16px;
    text-align: center;
    color: #8c8c8c;
    font-size: 13px;
  }
  
  :deep(.el-dropdown-menu__item) {
    padding: 8px 16px;
    
    &.is-disabled {
      color: inherit;
      cursor: not-allowed;
      
      &:hover {
        background: transparent;
      }
    }
  }
}


// 修改水印相关样式
.mainbox {
  position: relative;
  z-index: 2;
  background: rgba(255, 255, 255, 0.9);
  
  .watermark-container {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    pointer-events: none;
    z-index: 0;
    
    .watermark {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      display: flex;
      flex-wrap: wrap;
      overflow: hidden;
      
      .watermark-item {
        flex: 0 0 300px;
        height: 150px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: rgba(0, 0, 0, 0.06);
        font-size: 18px;
        transform: rotate(-30deg);
        user-select: none;
        white-space: nowrap;
        font-family: "Microsoft YaHei", sans-serif;
      }
    }
  }
  
  .info-section {
    position: relative;
    z-index: 1;
    background: transparent;
  }
}

// 流程管理样式
.process-container {
  display: flex;
  gap: 24px;
  min-height: 500px;
  
  .setup-list {
    width: 400px;
    flex-shrink: 0;
    border: 1px solid #f0f0f0;
    border-radius: 4px;
    
    :deep(.el-tabs) {
      height: 100%;
      
      .el-tabs__header {
        margin-right: 0;
      }
      
      .el-tabs__nav {
        width: 100%;
      }
      
      .el-tabs__item {
        text-align: left;
        height: 40px;
        line-height: 40px;
        padding: 0 20px;
        
        &.is-active {
          background: #e6f7ff;
        }
      }
    }
    
    .list-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 12px 16px;
      border-bottom: 1px solid #f0f0f0;
      
      h5 {
        margin: 0;
        font-size: 14px;
        color: #262626;
      }
    }
    
    .nodes {
      padding: 12px;
      
      .node-item {
        margin-bottom: 12px;
        border-radius: 4px;
        cursor: pointer;
        transition: all 0.3s;
        
        &:last-child {
          margin-bottom: 0;
        }
        
        .node-content {
          padding: 12px;
          background: #fafafa;
          border: 1px solid #f0f0f0;
          border-radius: 4px;
          transition: all 0.3s;
          
          .node-header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 8px;
            
            .node-name {
              font-size: 14px;
              color: #262626;
            }
          }
          
          .node-info {
            font-size: 12px;
            color: #8c8c8c;
            
            span {
              margin-right: 16px;
              
              i {
                margin-right: 4px;
              }
            }
          }
        }
        
        // 修改选中状态样式，提高优先级
        &.active {
          .node-content {
            background: #eff183  !important; // 添加 !important
            border-color: #97dd2b  !important;
            box-shadow: 0 2px 8px rgba(24,144,255,0.15);
            
            .node-name {
              color: #1890ff;
              font-weight: 500;
            }
          }
        }
        
        // 修改其他状态样式
        &.completed .node-content {
          background: #e5f9ff;
          border-color: #d0e4f7;
        }
        
        &.processing .node-content {
          background: #a0daff;
          border-color: #64b7e1;
        }
        
        // 添加悬浮效果，但不影响选中状态
        &:not(.active):hover .node-content {
          background: #f5f5f5;
          border-color: #d9d9d9;
        }
      }
    }
  }
  
  .node-detail {
    flex: 1;
    min-width: 0;
    border: 1px solid #f0f0f0;
    border-radius: 4px;
    padding: 24px;
    background: #fff;
    
    .detail-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 24px;
      padding-bottom: 16px;
      border-bottom: 1px solid #f0f0f0;
      
      h4 {
        margin: 0;
        font-size: 16px;
        font-weight: 500;
        color: #262626;
      }
    }
    
    // 优化工作记录样式
    .node-worklog {
      margin-bottom: 32px;
      background: #fafafa;
      border-radius: 8px;
      padding: 20px;
      
      .worklog-title {
        font-size: 15px;
        color: #262626;
        margin-bottom: 20px;
        font-weight: 500;
        padding-left: 8px;
        border-left: 3px solid #1890ff;
      }
      
      .worklog-list {
        margin-bottom: 20px;
        
        .worklog-item {
          background: #fff;
          border-radius: 8px;
          margin-bottom: 16px;
          box-shadow: 0 1px 2px rgba(0,0,0,0.03);
          
          &:last-child {
            margin-bottom: 0;
          }
          
          .log-header {
            padding: 12px 16px;
            border-bottom: 1px solid #f5f5f5;
            display: flex;  // 修改��� flex 布局
            justify-content: space-between;  // 两端对齐
            align-items: center;  // 垂直居中
            
            .user-info {
              display: flex;
              align-items: center;
              gap: 12px;
              
              .user-meta {
                display: flex;
                flex-direction: column;
                
                .username {
                  font-size: 14px;
                  font-weight: 500;
                  color: #262626;
                  line-height: 1.4;
                }
                
                .time {
                  font-size: 12px;
                  color: #8c8c8c;
                  line-height: 1.4;
                }
              }
            }
          }
          
          // 添加标签样式
          :deep(.el-tag) {
            font-size: 12px;
            height: 22px;
            line-height: 20px;
            padding: 0 8px;
            border-radius: 2px;
            
            &.el-tag--success {
              background: #f6ffed;
              border-color: #b7eb8f;
              color: #52c41a;
            }
          }
          
          .log-body {
            padding: 16px;
            color: #595959;
            line-height: 1.6;
            font-size: 14px;
            white-space: pre-wrap;
            word-break: break-all;
          }
        }
      }
      
      .worklog-input {
        background: #fff;
        padding: 16px;
        border-radius: 8px;
        box-shadow: 0 1px 2px rgba(0,0,0,0.03);
        
        :deep(.el-textarea__inner) {
          border-color: #e8e8e8;
          
          &:focus {
            border-color: #40a9ff;
          }
        }
        
        .input-footer {
          margin-top: 12px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          
          .visibility-switch {
            :deep(.el-switch__label) {
              color: #8c8c8c;
              font-size: 13px;
              
              &.is-active {
                color: #1890ff;
              }
            }
          }
        }
        
        .el-button {
          padding: 10px 20px;
        }
      }
    }
    
    // 优化通知设置样式
    .node-notice {
      background: #fafafa;
      border-radius: 8px;
      padding: 20px;
      
      .notice-title {
        font-size: 15px;
        color: #262626;
        margin-bottom: 20px;
        font-weight: 500;
        padding-left: 8px;
        border-left: 3px solid #1890ff;
      }
      
      .notice-items {
        margin-bottom: 24px;
        
        .notice-item {
          position: relative;
          background: #fff;
          border-radius: 8px;
          padding: 20px;
          margin-bottom: 16px;
          box-shadow: 0 1px 2px rgba(0,0,0,0.03);
          transition: all 0.3s;
          
          &:last-child {
            margin-bottom: 0;
          }
          
          &:hover {
            box-shadow: 0 4px 12px rgba(0,0,0,0.08);
            
            .send-btn {
              margin-top: 1px;
              opacity: 1;
              transform: translateX(0);
            }
          }

          .label {
            color: #8c8c8c;
            font-size: 14px;
            margin-bottom: 8px;
            display: block;
          }

          .content {
            color: #262626;
            line-height: 1.6;
            background: #f8f8f8;
            padding: 12px 16px;
            border-radius: 4px;
            margin-bottom: 12px;
            font-size: 14px;
            border: 1px solid #f0f0f0;
          }

          .send-btn {
            opacity: 0;
            transform: translateX(10px);
            transition: all 0.3s;
            position: absolute;
            right: 20px;
            top: 50%;
            margin-top: -16px;
          }
        }
      }
      
      // 消息记录列表样式
      .message-list {
        .list-title {
          font-size: 14px;
          color: #8c8c8c;
          margin-bottom: 16px;
          padding-bottom: 12px;
          border-bottom: 1px solid #f0f0f0;
        }
        
        .message-items {
          .message-item {
            background: #fff;
            border-radius: 8px;
            padding: 16px;
            margin-bottom: 12px;
            box-shadow: 0 1px 2px rgba(0,0,0,0.03);
            
            &:last-child {
              margin-bottom: 0;
            }
            
            .msg-header {
              display: flex;
              justify-content: space-between;
              align-items: center;
              margin-bottom: 12px;
              
              .msg-type {
                font-size: 13px;
                color: #1890ff;
                background: rgba(24,144,255,0.1);
                padding: 4px 12px;
                border-radius: 4px;
              }
              
              .msg-time {
                font-size: 12px;
                color: #8c8c8c;
              }
            }
            
            .msg-content {
              color: #262626;
              line-height: 1.6;
              margin-bottom: 12px;
              padding: 12px 16px;
              background: #fafafa;
              border-radius: 4px;
              border: 1px solid #f0f0f0;
              font-size: 14px;
            }
            
            .msg-phone {
              font-size: 12px;
              color: #8c8c8c;
              padding-left: 4px;
            }
          }
        }
      }
    }
  }
}

// 添加只读表单样式
.form-readonly {
  .form-item {
    margin-bottom: 16px;
    display: flex;
    align-items: flex-start;
    
    &:last-child {
      margin-bottom: 0;
    }
    
    .form-label {
      width: 100px;
      color: #8c8c8c;
      padding-right: 12px;
      line-height: 32px;
      text-align: right;
    }
    
    .form-value {
      flex: 1;
      min-height: 32px;
      line-height: 32px;
      color: #262626;
      padding: 0 12px;
      background: #fafafa;
      border-radius: 4px;
      
      // 处理多行文本
      white-space: pre-wrap;
      word-break: break-all;
      
      &:empty::after {
        content: '-';
        color: #bfbfbf;
      }
    }
  }
}

// 优化节点表单样式
.node-form {
  margin-bottom: 32px;
  background: #fafafa;
  border-radius: 8px;
  padding: 20px;
  
  .form-title {
    font-size: 15px;
    color: #262626;
    margin-bottom: 20px;
    font-weight: 500;
    padding-left: 8px;
    border-left: 3px solid #1890ff;
  }
  
  // 可编辑表单样式
  :deep(.el-form) {
    background: #fff;
    padding: 20px;
    border-radius: 8px;
    box-shadow: 0 1px 2px rgba(0,0,0,0.03);
    
    .el-form-item {
      margin-bottom: 20px;
      
      &:last-child {
        margin-bottom: 0;
      }
      
      .el-form-item__label {
        color: #595959;
        font-weight: 500;
        padding-right: 16px;
      }
      
      .el-input__inner {
        border-color: #e8e8e8;
        
        &:focus {
          border-color: #40a9ff;
        }
        
        &:hover {
          border-color: #40a9ff;
        }
      }
      
      .el-textarea__inner {
        border-color: #e8e8e8;
        
        &:focus {
          border-color: #40a9ff;
        }
        
        &:hover {
          border-color: #40a9ff;
        }
      }
      
      .el-switch {
        .el-switch__core {
          border-color: #e8e8e8;
        }
      }
    }
  }
  
  // 只读表单样式
  .form-readonly {
    background: #fff;
    padding: 20px;
    border-radius: 8px;
    box-shadow: 0 1px 2px rgba(0,0,0,0.03);
    
    .form-item {
      margin-bottom: 20px;
      display: flex;
      align-items: flex-start;
      
      &:last-child {
        margin-bottom: 0;
      }
      
      .form-label {
        width: 100px;
        color: #595959;
        font-weight: 500;
        padding-right: 16px;
        line-height: 32px;
        text-align: right;
      }
      
      .form-value {
        flex: 1;
        min-height: 32px;
        line-height: 1.8;
        color: #262626;
        padding: 8px 16px;
        background: #fafafa;
        border-radius: 4px;
        border: 1px solid #f0f0f0;
        
        // 处理多行文本
        white-space: pre-wrap;
        word-break: break-all;
        
        &:empty::after {
          content: '-';
          color: #bfbfbf;
        }
        
        // 开关类型的值样式
        .el-tag {
          margin: 4px 0;
        }
      }
    }
  }
  
  .form-edit {
    background: #fff;
    padding: 20px;
    border-radius: 8px;
    box-shadow: 0 1px 2px rgba(0,0,0,0.03);
    
    .form-footer {
      margin-top: 24px;
      padding-top: 16px;
      border-top: 1px solid #f0f0f0;
      text-align: right;
      
      .el-button {
        padding: 0 24px;
        height: 36px;
      }
    }
  }
}

// 优化表单内的行间距
.el-row {
  margin-bottom: 0 !important;
  
  &:last-child {
    margin-bottom: 0 !important;
  }
}

// 优化开关样式
:deep(.el-switch) {
  &.is-checked {
    .el-switch__core {
      border-color: #1890ff;
      background-color: #1890ff;
    }
  }
}

// 优化标签样式
:deep(.el-tag) {
  border-radius: 2px;
  padding: 0 8px;
  height: 24px;
  line-height: 22px;
  
  &.el-tag--success {
    background: #f6ffed;
    border-color: #b7eb8f;
    color: #52c41a;
  }
  
  &.el-tag--info {
    background: #f5f5f5;
    border-color: #d9d9d9;
    color: #8c8c8c;
  }
}

// 添加表单验证错误样式
:deep(.el-form-item.is-error) {
  .el-input__inner,
  .el-textarea__inner {
    border-color: #f56c6c;
    
    &:focus {
      border-color: #f56c6c;
    }
  }
  
  .el-form-item__error {
    padding-top: 4px;
    color: #f56c6c;
  }
}

// 添加当事人信息样式
.party-info {
  margin-bottom: 24px;
  padding-bottom: 24px;
  border-bottom: 1px dashed #f0f0f0;
  
  &:last-child {
    margin-bottom: 0;
    padding-bottom: 0;
    border-bottom: none;
  }
  
  .party-title {
    font-size: 14px;
    color: #595959;
    margin-bottom: 16px;
    padding-left: 12px;
    position: relative;
    
    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
      width: 4px;
      height: 14px;
      background: #1890ff;
      border-radius: 2px;
    }
  }
}

// 添加冲突预警样式
.conflict-list {
  .conflict-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px;
    background: #fff1f0;
    border: 1px solid #ffccc7;
    border-radius: 8px;
    margin-bottom: 12px;
    transition: all 0.3s;
    
    &:last-child {
      margin-bottom: 0;
    }
    
    &:hover {
      background: #fff2f0;
      border-color: #ffa39e;
      
      .view-btn {
        opacity: 1;
        transform: translateX(0);
      }
    }
    
    .conflict-content {
      flex: 1;
      margin-right: 16px;
      
      .case-title {
        display: flex;
        align-items: center;
        margin-bottom: 8px;
        
        .title {
          font-size: 14px;
          color: #434343;
          font-weight: 500;
          margin-right: 12px;
        }
        
        .proxy-type {
          font-size: 12px;
          padding: 2px 8px;
          border-radius: 2px;
          
          &.proxy-type1 {
            color: #1890ff;
            background: rgba(24,144,255,0.1);
          }
          
          &.proxy-type2 {
            color: #ff4d4f;
            background: rgba(255,77,79,0.1);
          }
          
          &.proxy-type3 {
            color: #faad14;
            background: rgba(250,173,20,0.1);
          }
        }
      }
      
      .case-info {
        font-size: 13px;
        color: #595959;
        margin-top: 10px;
        
        .info-item {
          margin-right: 24px;
          
          i {
            margin-right: 4px;
            font-size: 14px;
          }
          
          &:last-child {
            margin-right: 0;
          }
        }
      }
    }
    
    .view-btn {
      opacity: 0;
      transform: translateX(10px);
      transition: all 0.3s;
      padding: 8px 16px;
      
      &:hover {
        color: #ff4d4f;
      }
    }
  }
}

// 添加图片和文件相关样式
.image-list {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  
  .image-item {
    width: 100px;
    height: 100px;
    border-radius: 4px;
    overflow: hidden;
    
    .el-image {
      width: 100%;
      height: 100%;
    }
  }
}

.file-list {
  .file-item {
    display: flex;
    align-items: center;
    padding: 8px 12px;
    background: #fafafa;
    border-radius: 4px;
    margin-bottom: 8px;
    
    &:last-child {
      margin-bottom: 0;
    }
    
    i {
      color: #8c8c8c;
      margin-right: 8px;
    }
    
    .file-name {
      flex: 1;
      color: #262626;
      margin-right: 12px;
    }
  }
}

:deep(.el-upload--picture-card) {
  width: 100px;
  height: 100px;
  line-height: 100px;
}

:deep(.el-upload-list--picture-card .el-upload-list__item) {
  width: 100px;
  height: 100px;
}

// 优化上传提示样式
:deep(.el-upload__tip) {
  font-size: 12px;
  color: #8c8c8c;
  line-height: 1.5;
  margin-top: 8px;
}

// 添加用户表单样式
.client-form {
  margin-bottom: 32px;
  background: #fafafa;
  border-radius: 8px;
  padding: 20px;
  
  .form-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 15px;
    color: #262626;
    margin-bottom: 20px;
    font-weight: 500;
    
    span {
      padding-left: 8px;
      border-left: 3px solid #1890ff;
    }
    
    .clear-btn {
      color: #ff4d4f;
      
      &:hover {
        color: #ff7875;
      }
      
      i {
        margin-right: 4px;
      }
    }
  }
  
  .form-content {
    background: #fff;
    padding: 20px;
    border-radius: 8px;
    box-shadow: 0 1px 2px rgba(0,0,0,0.03);
    
    .form-item {
      display: flex;
      margin-bottom: 16px;
      
      &:last-child {
        margin-bottom: 0;
      }
      
      .form-label {
        width: 120px;
        color: #595959;
        font-weight: 500;
        padding-right: 16px;
        line-height: 32px;
        text-align: right;
      }
      
      .form-value {
        flex: 1;
        min-height: 32px;
        line-height: 32px;
        color: #262626;
        padding: 0 12px;
        background: #fafafa;
        border-radius: 4px;
        
        // 处理多行文本
        white-space: pre-wrap;
        word-break: break-all;
        
        &:empty::after {
          content: '-';
          color: #bfbfbf;
        }
        
        // 图片列表样式
        .image-list {
          display: flex;
          flex-wrap: wrap;
          gap: 8px;
          padding: 8px 0;
          
          .image-item {
            width: 80px;
            height: 80px;
            border-radius: 4px;
            overflow: hidden;
            border: 1px solid #f0f0f0;
            
            .el-image {
              width: 100%;
              height: 100%;
            }
          }
        }
        
        // 标签样式
        .el-tag {
          margin: 4px 0;
        }
      }
    }
  }
}

.worklog-item {
  // ... 其他样式保持不变
  
  .log-header {
    // ... 其他样式保持不变
    
    .log-actions {
      display: flex;
      align-items: center;
      gap: 8px;
      
      .visible-tag {
        cursor: pointer;
        transition: all 0.3s;
        
        &:hover {
          opacity: 0.8;
        }
      }
      
      .delete-btn {
        opacity: 0;  // 默认隐藏
        transition: all 0.3s;
        padding: 4px;
        color: #8c8c8c;
        
        &:hover {
          color: #ff4d4f;
          background: rgba(255, 77, 79, 0.1);
          border-radius: 4px;
        }
      }
    }
  }
  
  &:hover {
    .log-actions {
      .delete-btn {
        opacity: 1;  // 鼠标经过时显示
      }
    }
  }
}

// 优化 loading 样式
:deep(.el-loading-mask) {
  background-color: rgba(255, 255, 255, 0.9);
  
  .el-loading-spinner {
    .el-loading-text {
      color: #1890ff;
      font-size: 14px;
    }
    
    .circular {
      .path {
        stroke: #1890ff;
      }
    }
  }
}

.notice-items {
  .notice-item {
    // ... existing code ...
    
    .notice-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 12px;
      
      .label {
        color: #8c8c8c;
        font-size: 14px;
      }
      
      .auto-time {
        display: flex;
        align-items: center;
        background: #f8f8f8;
        padding: 4px 12px;
        border-radius: 4px;
        border: 1px solid #f0f0f0;
        
        .time-label {
          color: #8c8c8c;
          font-size: 13px;
          margin-right: 8px;
        }
        
        .time-value {
          color: #262626;
          font-size: 13px;
          font-family: Consolas, monospace;
        }
        
        .edit-time-btn {
          padding: 2px 4px;
          margin-left: 8px;
          
          &:hover {
            color: #40a9ff;
            background: rgba(24,144,255,0.1);
            border-radius: 2px;
          }
        }
      }
    }
  }
}

.time-dialog {
  // ... existing code ...
  
  .el-form-item {
    margin-bottom: 20px;
    
    &:last-child {
      margin-bottom: 0;
    }
  }
}

.time-dialog-footer {
  text-align: right;
  padding-top: 20px;
}

.time-dialog-footer .el-button {
  margin-left: 10px;
}

.auto-time {
                display: flex;
          align-items: center;
          background: #f8f8f8;
          padding: 4px 12px;
          border-radius: 4px;
          border: 1px solid #f0f0f0;
          
          .time-label {
                  color: #8c8c8c;
          }
        }

.schedule-info {
  padding: 20px;
  background: #fafafa;
  border-radius: 8px;
  
  .time-box {
    .time-item {
      display: flex;
      align-items: center;
      background: #fff;
      padding: 16px 20px;
      border-radius: 8px;
      margin-bottom: 16px;
      border: 1px solid #f0f0f0;
      transition: all 0.3s;
      
      &:last-child {
        margin-bottom: 0;
      }
      
      &:hover {
        box-shadow: 0 2px 8px rgba(0,0,0,0.04);
        border-color: #e6f7ff;
      }
      
      i {
        font-size: 24px;
        color: #1890ff;
        margin-right: 16px;
      }
      
      .info {
        flex: 1;
        
        .label {
          font-size: 13px;
          color: #8c8c8c;
          margin-bottom: 4px;
        }
        
        .value {
          font-size: 16px;
          color: #262626;
          font-weight: 500;
          font-family: Consolas, monospace;
          
          &.expired {
            color: #ff4d4f;
          }
          
          &.today {
            color: #1890ff;
          }
          
          &.warning {
            color: #faad14;
          }
          
          &.normal {
            color: #52c41a;
          }
        }
      }
      
      .edit-btn {
        padding: 8px 16px;
        font-size: 14px;
        color: #1890ff;
        transition: all 0.3s;
        border-radius: 4px;
        
        i {
          font-size: 14px;
          margin-right: 4px;
          color: inherit;
        }
        
        &:hover {
          background: rgba(24,144,255,0.1);
        }
      }
    }
  }
}

// ... 其他样式 ...

.node-detail {
  flex: 1;
  min-width: 0;
  border: 1px solid #f0f0f0;
  border-radius: 4px;
  padding: 24px;
  background: #fff;
  
  .detail-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 24px;
    padding-bottom: 16px;
    border-bottom: 1px solid #f0f0f0;
    
    h4 {
      margin: 0;
      font-size: 16px;
      font-weight: 500;
      color: #262626;
    }
  }

  // 计划时间样式
  .schedule-box {
    margin-bottom: 24px;
    background: #fafafa;
    border-radius: 8px;
    padding: 16px;
    
    .time-box {
      .el-row {
        margin: 0 !important;
      }
      
      .time-item {
        display: flex;
        align-items: center;
        background: #fff;
        padding: 12px 16px;
        border-radius: 4px;
        border: 1px solid #f0f0f0;
        transition: all 0.3s;
        height: 100%;
        
        &:hover {
          box-shadow: 0 2px 8px rgba(0,0,0,0.04);
          border-color: #e6f7ff;
        }
        
        i {
          font-size: 20px;
          color: #1890ff;
          margin-right: 12px;
        }
        
        .info {
          flex: 1;
          min-width: 0;
          
          .label {
            font-size: 13px;
            color: #8c8c8c;
            margin-bottom: 2px;
          }
          
          .value {
            font-size: 14px;
            color: #262626;
            font-weight: 500;
            font-family: Consolas, monospace;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            
            &.expired {
              color: #ff4d4f;
            }
            
            &.today {
              color: #1890ff;
            }
            
            &.warning {
              color: #faad14;
            }
            
            &.normal {
              color: #52c41a;
            }
          }
        }
        
        .edit-btn {
          padding: 6px 12px;
          font-size: 13px;
          color: #1890ff;
          transition: all 0.3s;
          border-radius: 4px;
          white-space: nowrap;
          
          i {
            font-size: 13px;
            margin-right: 4px;
            color: inherit;
          }
          
          &:hover {
            background: rgba(24,144,255,0.1);
          }
        }
      }
    }
  }
}

// ... 其他样式 ...

.worklog-container {
  background: #fff;
  border-radius: 8px;
  padding: 20px;
  
  .worklog-list {
    .worklog-item {
      background: #fafafa;
      border-radius: 8px;
      padding: 16px;
      margin-bottom: 16px;
      transition: all 0.3s;
      
      &:last-child {
        margin-bottom: 0;
      }
      
      &:hover {
        box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
      }
      
      .log-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 12px;
        
        .user-info {
          display: flex;
          align-items: center;
          gap: 12px;
          
          .user-meta {
            display: flex;
            flex-direction: column;
            
            .username {
              font-size: 14px;
              font-weight: 500;
              color: #262626;
              line-height: 1.4;
            }
            
            .time {
              font-size: 12px;
              color: #8c8c8c;
              line-height: 1.4;
            }
          }
        }
        
        .log-actions {
          .visible-tag {
            font-size: 12px;
            height: 22px;
            line-height: 20px;
            padding: 0 8px;
            border-radius: 2px;
            background: #f6ffed;
            border-color: #b7eb8f;
            color: #52c41a;
          }
        }
      }
      
      .log-content {
        color: #595959;
        line-height: 1.6;
        font-size: 14px;
        white-space: pre-wrap;
        word-break: break-all;
      }
    }
  }
}

:deep(.el-dialog__body) {
  padding: 20px 24px;
}

.dialog-footer {
  text-align: right;
  padding-top: 20px;
}
.print-btn{
  margin-left: 50px;
  cursor: pointer;
}

.person-group {
  margin-bottom: 24px;
  
  &:last-child {
    margin-bottom: 0;
  }
  
  .group-title {
    font-size: 14px;
    color: #595959;
    margin-bottom: 16px;
    padding-left: 12px;
    position: relative;
    
    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
      width: 4px;
      height: 14px;
      background: #1890ff;
      border-radius: 2px;
    }
  }
  
  .person-list {
    .person-item {
      background: #fafafa;
      border-radius: 8px;
      padding: 16px;
      margin-bottom: 12px;
      transition: all 0.3s;
      border: 1px solid #f0f0f0;
      
      &:last-child {
        margin-bottom: 0;
      }
      
      &:hover {
        background: #f5f5f5;
        border-color: #e6f7ff;
      }
      
      &.main-person {
        background: #fff;
        border-color: #91d5ff;
        
        &:hover {
          background: #f0f7ff;
        }
      }
      
      .person-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 12px;
        
        .person-name {
          display: flex;
          align-items: center;
          gap: 8px;
          
          .name {
            font-size: 14px;
            font-weight: 500;
            color: #262626;
          }
          
          .remark {
            color: #8c8c8c;
            font-size: 13px;
          }
        }
        
        .person-actions {
          display: flex;
          gap: 8px;
          
          .el-button {
            padding: 4px 8px;
            
            &:hover {
              background: rgba(0,0,0,0.03);
              border-radius: 4px;
            }
          }
        }
      }
      
      .person-info {
        display: flex;
        flex-wrap: wrap;
        gap: 12px;
        
        .info-item {
          flex: 1;
          min-width: 200px;
          
          &.full-width {
            flex: 0 0 100%;
          }
          
          .label {
            color: #8c8c8c;
            margin-right: 8px;
          }
          
          .value {
            color: #262626;
            word-break: break-all;
          }
        }
      }
    }
  }
}

.quick-input-buttons {
  margin-top: 8px;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  
  .el-button {
    margin: 0;
    padding: 4px 8px;
    font-size: 12px;
    color: #1890ff;
    background: #f0f7ff;
    border-radius: 2px;
    
    &:hover {
      color: #40a9ff;
      background: #e6f7ff;
    }
  }
}

.relation-buttons {
  margin-top: 8px;
  
  .el-button {
    margin: 0 4px 4px 0;
    padding: 2px 8px;
    font-size: 12px;
    color: #595959;
    background: #f5f5f5;
    border-radius: 2px;
    
    &:hover {
      color: #262626;
      background: #e8e8e8;
    }
  }
}
.info-item-warning{
  margin-top: 10px;
  
  font-size: 14px;

  .value{
    cursor: pointer;
  }
  .warning-item{
    padding: 10px;
    border: 1px solid #f0f0f0;
    border-radius: 4px;
    margin-bottom: 10px;
    background-color: #f8d0d0;
  }
}
</style>

